{
  "settings" : {
    "calendar" : {
      "calendar_settings" : "Definições de calendário",
      "settings" : "Definições",
      "select_calendar_type" : "Selecionar o Tipo de calendário",
      "add_new_calendar_group" : "Adicionar novo Grupo de calendário",
      "add_new_equipment" : "Adicionar novo Equipamento",
      "new_calendar" : "Calendário novo",
      "calendar_group_description" : "Utilize o Grupo de calendários para Ordenar e Grupo de forma eficaz vários calendários juntos.",
      "group" : "Grupo",
      "manage_your_calendars_and_groups" : "Gerir os seus calendários e o Grupo",
      "groups" : "Grupo",
      "create_group" : "Criar Grupo",
      "create_calendar" : "Criar calendário",
      "calendar_name" : "Nome do calendário",
      "group_duration" : "Duração do Grupo",
      "calendar_type" : "Tipo",
      "action" : "Ação",
      "round_robin" : "Distribuição sequencial",
      "event" : "Evento",
      "group_name" : "Nome do Grupo",
      "room_name" : "Nome do Quarto",
      "group_description" : "Descrição do Grupo",
      "calendar_url" : "URL do calendário",
      "calendars" : "Calendários",
      "date_updated" : "Data de Atualizado",
      "status" : "Estado",
      "action_dropdown" : "Menu suspenso de Ação",
      "calendar_list" : "Serviços Membros para",
      "edit" : "Editar",
      "duplicate" : "Duplicar",
      "copy_embed_code" : "Copiar Código de incorporação",
      "copy_permanent_link" : "Copiar Ligar, vincular permanente",
      "copy_new_slug_link" : "Copiar Ligação de agendamento",
      "copy_scheduling_link" : "Copiar Ligação de agendamento (Legado descontinuado)",
      "deactivate_calendar" : "Calendário suspenso",
      "move_to_group" : "Mover para o Grupo",
      "delete_calendar" : "Eliminar calendário",
      "delete_group" : "Eliminar",
      "delete_this_group" : "Eliminar este Grupo",
      "activate_calendar" : "Calendário acionador",
      "duration" : "Duração",
      "all" : "todos",
      "draft" : "Rascunhar",
      "inactive" : "Inativo",
      "active" : "Dinâmico",
      "actions" : "atividades",
      "rearrange_calendars" : "Calendários reagendados",
      "deactivate_all_calendars_in_group" : "Suspender todos os calendários in Grupo",
      "activate_all_calendars_in_group" : "acionador todos os calendários in Grupo",
      "no_groups_found" : "A sua Pesquisa não correspondeu a nenhum calendário do Grupo.",
      "no_groups_in_location" : "Grupo Ordenar os seus calendários Gosto Pasta. Adicionar calendários a um Grupo e Partilhar uma Ligação Individual de agendamento, deixando o Responsável pelas marcações selecionar De vários calendários.",
      "no_calendars_found" : "Começar a trabalhar Via calendário Via novo calendário Criado.",
      "no_calendars_found_search" : "A sua Pesquisa não encontrou nenhum calendário.",
      "delete_calendar_message" : "utilizador're Acerca de para eliminar Calendário. Quando o utilizador Visualizações eliminar, também eliminará todos o seu Compromisso.",
      "delete_calendar_message_title" : "Eliminar este calendário?",
      "duplicate_calendar_message" : "utilizador're Acerca de to Duplicar Calendário. Isto irá Criar um novo calendário com as mesmas Definições do calendário Selecionado.",
      "duplicate_calendar_message_title" : "Duplicar este calendário?",
      "no_calendars_found_title" : "Nenhum calendário encontrado",
      "no_groups_in_location_title" : "Nenhum Grupo encontrado",
      "delete_group_confirmation_title" : "Eliminar este Grupo?",
      "delete_group_confirmation" : "O utilizador tem a certeza de que pretende eliminar o Grupo Selecionado?",
      "delete_group_confirmation_checkbox_title" : "Eliminar calendários dos Membros e Compromisso",
      "delete_group_confirmation_checkbox_description" : "Selecionar esta opção também irá eliminar os calendários in Grupo, juntamente com todos os Compromissos in calendários.",
      "group_status_message_title" : "{status} Grupo e todos os Membros Calendários?",
      "calendar_status_message_title" : "{status} este calendário?",
      "calendar_status_message" : "utilizador're Acerca de para {status} Calendário",
      "group_status_active_message" : "O utilizador tem a certeza de que o utilizador pretende acionador este Grupo? todos os calendários do Grupo também serão Ativados e disponíveis para reserva",
      "group_status_inactive_message" : "O utilizador tem a certeza de que o utilizador pretende suspender este Grupo? todos os calendários dentro do Grupo também serão Desativado e disponíveis para reserva",
      "coming_soon" : "Brevemente",
      "select" : "Selecionar",
      "15mins" : "15 minutos",
      "cancel" : "Cancelar",
      "save" : "Arquivo",
      "create" : "Criar",
      "select_calendar_group" : "Selecionar Grupo de calendário",
      "move_calendar_confirmation" : "Tenha em atenção que o antigo Ligar, vincular deixaria de funcionar assim que o utilizador Prosseguir com o Alterar. Confirme Via a Caixa de verificação.",
      "previously_called_unassigned" : " (Anteriormente chamado como não atribuído)",
      "scheduling_type" : "Selecionar Tipo de calendário",
      "scheduling_type_description" : "Selecione um Tipo de calendário para Configurar o seu calendário e Personalizar como o Compromisso é Agendado.",
      "service_menu_name" : "Nome do menu de serviços",
      "template" : "Modelo",
      "select_template" : "Selecionar modelo",
      "group_url" : "URL do Grupo",
      "template_description" : "o utilizador agora tem a opção de selecionar Ou os modelos Clássico Ou Neo para o Grupo Ver",
      "rooms" : "Quarto",
      "rooms_name" : "Nome",
      "rooms_description" : "Descrição",
      "rooms_modal_description" : "Adicionar ou editar quarto",
      "rooms_capacity" : "Capacidade Total",
      "no_rooms_in_location_title" : "Nenhum quarto encontrado",
      "no_rooms_in_location" : "Nenhum Quarto encontrado in Localização",
      "no_equipments_in_location" : "Nenhum Equipamento encontrado in Localização",
      "equipments" : "Equipamento",
      "equipment_name" : "Nome",
      "equipment_name_search" : "Nome do Equipamento",
      "equipment_description" : "Descrição",
      "equipment_modal_description" : "Adicionar ou editar um equipamento",
      "add_equipment" : "Adicionar/ Editar Equipamento",
      "add_room" : "Adicionar/ Editar Quarto",
      "equipment_quantity" : "Quantidade Total",
      "equipment_outOfService" : "Quantidade de serviço",
      "no_equipments_in_location_title" : "Nenhum Equipamento encontrado",
      "delete_this_equipment" : "Eliminar este Equipamento",
      "delete_this_rooms" : "Eliminar este Quarto",
      "delete_equipment_confirmation" : "O utilizador tem certeza, utilizador, pretende eliminar este Equipamento? Este será Eliminado De todos os Calendários de terceiros também.",
      "delete_rooms_confirmation" : "O utilizador tem certeza, utilizador pretende eliminar este Quarto? Este será Eliminado De todos os Calendários de terceiros também.",
      "add_new_calendar_equipments" : "Adicionar novo Equipamento",
      "no_equipments_found" : "A sua Pesquisa não encontrou nenhum Equipamento.",
      "no_rooms_found" : "A sua Pesquisa não encontrou nenhum Quarto.",
      "add_new_calendar_rooms" : "Adicionar novo Quarto",
      "rooms_disable" : "Desativar Quarto",
      "equipments_disable" : "Desativar Equipamento",
      "equipments_activate" : "acionador Equipamento",
      "rooms_activate" : "acionador Quarto",
      "create_equipments" : "Criar Equipamento",
      "create_rooms" : "Criar Quarto",
      "select_calendar_rooms_title" : "Selecionar calendário",
      "select_calendar_rooms_description" : "o utilizador pode selecionar vários calendários para Afiliado com Quarto",
      "select_calendar_equipments_title" : "Selecionar calendário",
      "select_calendar_equipments_description" : "o utilizador pode selecionar um calendário para Afiliado com o Equipamento",
      "disable_equipment_title" : "{status} Equipamento",
      "disable_room_title" : "{status} Quarto",
      "equipments_status_message" : "O utilizador tem a certeza de que o utilizador pretende {status} este Equipamento?",
      "rooms_status_message" : "O utilizador tem a certeza de que pretende {status} este Quarto?",
      "calendar_resource_disclaimer" : "Isto pode afetar os calendários de serviço da Disponibilidade Ativado Membros.",
      "equipment_disclaimer" : "Nota: Ativar o Equipamento mais tarde irá automaticamente Restabelecer ligação-lo para calendários com os quais é Membros com",
      "room_disclaimer" : "Nota: Ativar o Quarto mais tarde irá automaticamente Restabelecer ligação-lo para calendários com os quais é Membros com",
      "equipment_tab_name" : "Equipamento",
      "rooms_tab_name" : "Quarto",
      "manage_your_rooms" : "Gerir Quarto para o seu Negócio aqui",
      "manage_your_equipments" : "Gerir Equipamento para o seu Negócio aqui",
      "select_service_calendar_description_equipments" : "o utilizador pode selecionar vários calendários de serviço para Afiliado com Equipamento",
      "select_service_calendar_description_rooms" : "o utilizador pode selecionar vários calendários de serviço para Afiliado com Quarto",
      "service_menus" : "Menu de serviços",
      "manage_your_calendars_groups_and_service_menus" : "Gerir os seus calendários, Grupo e menu de serviços",
      "new_service_menu" : "Criar menu de serviços",
      "deactivate_service_menu" : "Menu de serviços suspensor",
      "delete_service_menu" : "Eliminar este menu de serviços",
      "delete_service_menu_confirmation" : "O utilizador tem a certeza de que pretende eliminar este menu de serviço?",
      "service_menu_status_message_title" : "{status} este menu de serviços?",
      "service_menu_status_message" : "utilizador're Acerca de para {status} Menu de serviços",
      "no_service_menus_in_location_title" : "Criar o seu Menu de serviços personalizado",
      "add_new_service_menu" : "Adicionar novo menu de serviços",
      "no_service_menus_in_location" : "Iniciar a Via Criado um novo menu de serviços e adicionar o Grupo a ele",
      "no_service_menu_found" : "Nenhum menu de serviços encontrado",
      "no_service_menu_found_desc" : "A sua Pesquisa não encontrou nenhum menu de serviço.",
      "apply" : "Aplicar",
      "troubleshoot_calendar" : "Resolução de problemas de calendário",
      "round_robin_booking" : "Distribuição sequencial",
      "round_robin_description" : "Distribui o Compromisso entre os Membros do Grupo in Ordenar giratório.",
      "round_robin_example" : "Ex: Chamadas de venda, Sessões de integração.",
      "unassigned_booking" : "Calendário de Evento",
      "unassigned_description" : "Para ocorrências físicas agendadas sem Relação de Anfitrião.",
      "unassigned_example" : "Ex: Conferências, webinars do Público, expositivos.",
      "event_booking_alert_title" : "Importante",
      "event_booking_alert_message" : "Este tipo de calendário tem diferenças importantes",
      "event_booking_know_more" : "Saber mais",
      "event_booking_tooltip_title" : "Informações importantes:",
      "event_booking_tooltip_content" : "• Não são suportadas ferramentas de ligação de reuniões dinâmicas (por exemplo, Zoom/Google Meet/MS Teams)\n• Não é possível atribuir um utilizador\n• Os eventos não são sincronizados com o calendário de um utilizador por predefinição\n• Só é possível sincronizar um único Calendário Google através da sincronização externa\n• Não são suportados calendários em conflito",
      "class_booking" : "Marcação de Aula",
      "class_booking_description" : "Um Anfitrião atende com vários Membros.",
      "class_booking_example" : "Ex: Webinars, Grupo Cursos, Cursos online .",
      "collective_booking" : "COLETIVO Reserva",
      "collective_booking_description" : "Vários anfitriãos reunem-se com um Membros.",
      "collective_booking_example" : "Por exemplo: Conversas de painéis, revisões de commissões.",
      "service_booking" : "Marcação de serviços",
      "service_booking_description" : "Agendar perfeito para empresas baseada em serviços.",
      "service_booking_example" : "Ex: Spa Compromisso, Serviços de reparação, consultas.",
      "personal_booking" : "Reserva pessoal",
      "personal_booking_description" : "agendar Reuniões um-Ativado-one com um Grupo Membros específico.",
      "personal_booking_example" : "Ex: Reuniões com clientes, Consultas Privado.",
      "personal" : "Pessoal",
      "explore_more_types" : "Explorar mais categorias",
      "no_calendars_added" : "Ainda sem calendários – Coleção One Up!",
      "no_calendars_added_description" : "Criar o seu primeiro calendário para começar a agendar sem esforço.",
      "no_groups_added" : "Ainda no Grupo – Comece a organizar!",
      "no_calendars_yet" : "Ainda sem calendário",
      "no_groups_yet" : "Ainda sem Grupo",
      "no_calendars_access" : "Nenhum calendário foi criado ainda. Depois de um calendário ser Criado, aparecerá aqui. o utilizador não tem Acesso para criar um calendário — contacte o seu Administrador Se necessário.",
      "no_groups_access" : "Nenhum Grupo ainda foi Configurar. Depois de um Grupo ser Criado, aparecerá aqui. o utilizador não tem Acesso para Criar a Grupo — contacte o seu Administrador Se necessário.",
      "no_groups_added_description" : "Utilize o Grupo para manter os seus calendários estruturados. Adicionar calendários a um Grupo e Partilhar um Grupo Individual Ligação de agendamento para reserva Simples.",
      "group_success_message" : "O Grupo é Criado com sucesso. o utilizador pode agora Incluir calendários a este Grupo.",
      "choose_calendars" : "Selecionar Calendários",
      "do_it_later" : "Fazer isso mais tarde",
      "add_calendars_to_group" : "Adicionar Calendários ao Grupo",
      "select_calendars_to_add" : "Selecione todos os calendários que o utilizador pretende Incluir ao Grupo {name}",
      "add_calendars" : "Adicionar calendário(s)",
      "continue" : "Continuar",
      "conflicting_calendars" : "Calendários em conflito",
      "conflicting_calendars_description" : "Os calendários à direita já fazem parte de Outros Grupo. O utilizador pretende Mover-os para o seu novo Grupo, <b>{name}</b>?",
      "group_associated_with" : "Grupo Atual",
      "move_calendar_consent" : "I Ativar A mover... estes calendários para o novo Grupo.",
      "calendars_moved_successfully" : "todos os calendários Selecionados foram movidos com sucesso para {name}.",
      "new_group" : "novo Grupo",
      "back" : "Voltar",
      "share_otl" : "Partilhe os seus Dados de Disponibilidade todos com um Ligar único, vincular que Expira Depois de uma reserva, assegurando o Acesso Gerir.",
      "copied_to_clipboard" : "Copiado para a área de transferência",
      "generate_link" : "Gerar novo Ligar, vincular",
      "generate_link_error" : "Não foi possível gerar uma ligação única. Tente novamente",
      "share_schedule_link" : " A Ligação de agendamento é determinada Via o Slug. Modifique o Slug e a Ligação de agendamento adapta-se automaticamente à modificação.",
      "share_permanent_link" : "Ideal para Funis, Redirecionamentos do Sítio Web, Ou Anúncios, o Ligar permanente, o vincular permanecem constantes, não afetados Via Slug Dinâmico.",
      "copy" : "Copiar",
      "share_embed_code" : "Localize este Código in seu HTML onde o utilizador pretende que o seu Widget {embedType} seja apresentado.",
      "scheduling_link" : "Ligação de agendamento",
      "permanent_link" : "Ligar, vincular permanente",
      "one_time_link" : "One Data Ligar, vincular",
      "embed_code" : "Código de incorporação",
      "loading" : "A carrregar......",
      "share_group" : "Partilhar Grupo",
      "edit_group" : "Editar Grupo",
      "more_options" : "Mais Opções",
      "share_calendar" : "Partilhar calendário",
      "edit_calendar" : "Editar calendário",
      "troubleshoot_calendar_link" : "Resolução de problemas de calendário",
      "calendar_config_success" : "o utilizador definiu com sucesso o seu calendário pessoal/do Grupo",
      "close" : " Fechar",
      "added_calendars" : "Calendário(s) adicionado(s)",
      "select_calendars" : "Selecionar calendário(s)",
      "settings_confirmation" : "Para a Prosseguir, verifique estas Dinâmico.",
      "consent_checkbox_title" : "Compreendo e aceitei estes Dinâmico",
      "confirm" : "Confirmar",
      "create_group_access_disabled" : "o utilizador não tem Autorização para Criar a Grupo. Contacte o seu Administrador para Acesso.",
      "create_calendar_access_disabled" : "o utilizador não tem Autorização para Criar um calendário. Contacte o seu Administrador para Acesso.",
      "preview_booking_widget" : "Pré-visualizar Widget de marcações",
      "share_service_menu" : "Partilhar menu de serviços",
      "back_message" : "Voltar à Lista de calendários",
      "service_calendars" : "Calendários de serviço",
      "owned_by" : "Propriedade de Via",
      "owned_by_anyone" : "Qualquer pessoa",
      "owned_by_me" : "Eu",
      "all_groups" : "todos o Grupo",
      "all_calendars" : "todos os calendários",
      "not_grouped" : "Não agrupado",
      "delete_group_desc" : "Tem a certeza do utilizador que pretende eliminar este Grupo? Isto também irá eliminar todos os calendários Membros com este Grupo.",
      "calendar_listing_title" : "Listagem de calendário",
      "calendar_group_name" : "Calendário/nome do Grupo",
      "success" : "Sucesso",
      "my_calendar" : "o meu calendário"
    },
    "preferences" : {
      "preferences" : "Definições",
      "my_preferences" : "A minha Preferência",
      "account_preferences" : "Preferências da conta",
      "user_preferences" : "Definições do utilizador",
      "set_preferences" : "Coleção as suas definições para a sua conta.",
      "scheduling_options" : "agendar Opções",
      "meeting_location" : "Conferência Localização",
      "zoom" : "Zoom",
      "save_preferences" : "Definições de Arquivo",
      "in_app_preferences" : "na Aplicação Definições",
      "set_start_day" : "Coleção Definições Gosto iniciar Dia para a aplicação",
      "view_options" : "Ver Opções",
      "services" : "Serviços",
      "feature_toggle_aria" : "Alternância de funcionalidade",
      "week_starts_on" : "A semana começa",
      "sunday" : "Domingo",
      "widget_preferences" : "Definições Widget",
      "set_widget_language" : "Coleção Definições Gosto Língua for Widget",
      "language_and_region" : "Língua e Estado",
      "language" : "Língua",
      "english" : "Inglês",
      "time_format" : "Formato da hora",
      "time_format_value" : "PM",
      "monday" : "Segunda-feira",
      "custom_meeting_location" : "Personalizado Conferência Localização",
      "view_appointments_in_1" : "Ver Compromissos em",
      "timezone_uses_details_1" : "Vamos usar este fuso horário para apresentar os horários dos compromissos em toda a aplicação e nos seus e-mails relacionados com os compromissos — só para si. Não afetará a sua disponibilidade ou a forma como os outros marcam consigo.",
      "business_timezones_1" : "Fuso horário da Empresa",
      "business_timezones_tooltip_1" : "Mensagem: Escolher esta opção assegura que a sua Preferência de visualização se alinha com o Fuso horário da Empresa selecionada. Se o fuso horário da Empresa mudar, o seu fuso horário de visualização será automaticamente ajustado para coincidir.",
      "recommended_timezones" : "Fusos horários recomendados",
      "all_timezones" : "Todos os fusos horários"
    },
    "availability" : {
      "availability" : "Disponibilidade",
      "my_availability" : "A minha Disponibilidade",
      "my_availability_and_booking_rules" : "Disponibilidade e Regras de Marcação",
      "my_availability_and_booking_rules_description" : "Configure a sua disponibilidade e defina como e quando este calendário aceita marcações — incluindo intervalos de reunião, limites e outras preferências de agendamento.",
      "account_availability" : "Disponibilidade da Conta",
      "timezone" : "Fuso horário",
      "working_hours" : "Horas de trabalho",
      "set_recurring_hours" : "Coleção o seu horário de trabalho Recorrente para Conferência",
      "select_one" : "Selecionar um",
      "sunday" : "Domingo",
      "monday" : "Segunda-feira",
      "tuesday" : "Terça-feira",
      "wednesday" : "Quarta-feira",
      "thursday" : "Quinta-feira",
      "friday" : "Sexta-feira",
      "saturday" : "Sábado",
      "widget_preferences" : "Definições Widget",
      "set_widget_language" : "Coleção Definições Gosto Língua for Widget",
      "language_and_region" : "Língua e Estado",
      "language" : "Língua",
      "english" : "Inglês",
      "copy_to_all" : "Copiar para todos",
      "save_availability" : "Arquivo Disponibilidade",
      "add_time" : "Adicionar dados",
      "to" : "Para",
      "select_time" : "Selecionar Dados",
      "add_user" : "Adicionar Utilizador",
      "accessRestricted" : {
        "header" : "Acesso Privado",
        "message" : "o utilizador não faz parte desta Conta. Para obter o Acesso, inclua-se nesta Conta Via Definições da agência > Grupo > Editar Grupo Membros, e atribua a Conta em \"Funções e Permissões\"",
        "contact_admin" : "Esta página é pública apenas para os administradores. Contacte o seu Administrador para obter assistência.",
        "button_text" : "Ir para Definições da Agência"
      },
      "schedule" : {
        "edit_schedule" : "Editar Agenda",
        "schedule_name" : "Nome da agenda",
        "schedule_name_required" : "O nome da programação é obrigatório",
        "timezone" : "Fuso horário",
        "timezone_placeholder" : "Selecionar um",
        "start_time" : "Hora de Início",
        "end_time" : "Hora de fim",
        "add_availability_hour" : "Adicionar hora de disponibilidade",
        "remove_availability_hour" : "Remover hora de disponibilidade",
        "unavailable" : "Indisponível",
        "schedule_created" : "Agenda criado com sucesso",
        "schedule_updated" : "Agenda atualizada com sucesso",
        "calendars_selected" : "{count} Calendário",
        "calendars_selected_multiple" : "{count} Calendários",
        "select_users_placeholder" : "Pesquisar utilizadores",
        "edit_default_schedule" : "Editar esta agenda",
        "customize_event_type_schedule" : "Personalizar agenda apenas para este calendário",
        "multi_user_description" : "<b>{count} utilizadores</b> estão selecionados, atualize a disponibilidade para <b>{calendar}</b>",
        "selected_calendar" : "calendário selecionado",
        "edit_schedule_alert" : "As atualizações feitas aqui serão aplicadas a",
        "schedule" : "Agendar",
        "no_availability" : "Sem disponibilidade",
        "date_specific_hours_show_more" : "mais",
        "date_specific_hours_show_less" : "menos",
        "date_specific_hours_recurring_meetings_enabled" : "Não é possível adicionar horas específicas por data porque esta agenda está ligada a um calendário com reuniões recorrentes ativadas. Para continuar, desative as reuniões recorrentes.",
        "recurring_incompatible_with_date_hours" : "As reuniões recorrentes não podem ser ativadas porque a agenda do utilizador tem horas específicas por data, o que é incompatível.",
        "incompatible_schedule_with_recurring" : "A agenda {user} contém horas específicas para determinadas datas, o que é incompatível com reuniões recorrentes.",
        "incompatible_schedule_with_recurring_calendar" : "A agenda contém horas específicas para datas, o que é incompatível com reuniões recorrentes.",
        "recurring_meetings_enabled_multi_user" : "As reuniões recorrentes requerem apenas um membro de equipa atribuído e a sua agenda não pode incluir horas específicas por data.",
        "weekdays" : "Dias úteis, {timeRange}",
        "weekdays_hours_vary" : "Dias úteis, horário variável",
        "weekend" : "Fim de semana, {timeRange}",
        "weekend_hours_vary" : "Fim de semana, horário variável",
        "days_hours_vary" : "{days}, horário variável",
        "date_specific_hours_tab_name" : "Horas específicas para datas",
        "date_specific_hours" : "{count} horas específicas por data",
        "date_specific_hours_1" : "1 hora específica por data",
        "weekly_hours" : "Horário Semanal",
        "custom_schedule" : "Agenda Personalizada",
        "select_schedule" : "Selecionar uma agenda",
        "no_schedules_found" : "Nenhuma agenda encontrada",
        "untitled" : "Sem título",
        "error_updating_schedules" : "Erro ao atualizar as agendas",
        "daily" : "Diário",
        "weekly" : "Semanal",
        "monthly" : "Mensal",
        "custom" : "Personalizado",
        "this_is_required" : "Isto é obrigatório",
        "search" : "Pesquisar",
        "edit_hours" : "Editar horas",
        "schedule_name_duplicate" : "Já existe uma agenda com este Nome",
        "delete_schedule_title" : "Eliminação da agenda '{scheduleName}'?",
        "delete_schedule_description" : "Esta ação não pode ser anulada. Tem a certeza de que pretende continuar?",
        "delete_schedule_negative_text" : "Anulado",
        "delete_schedule_positive_text" : "Sim, eliminar",
        "active_on" : "Dinâmico Ativado",
        "weekly_working_hours" : "Horário de trabalho semanal",
        "weekly_working_hours_subtext" : "Selecione os dias e horários em que trabalha",
        "copy_availability_hour" : "Copiar hora de disponibilidade",
        "mins" : "Minutos",
        "hours" : "Horas"
      }
    },
    "connections" : {
      "connections" : "Conexões",
      "connect" : "ligar",
      "conferencing" : "Conferência",
      "my_connections" : "As minhas ligações",
      "account_connections" : "Conexões da Conta",
      "connection_preferences" : "Definições de ligação",
      "manage_calendars_conferencing_channels" : "Gerir Calendários e canais de Conferência",
      "main_integration_calendar" : "Calendário de integração do PRIMÁRIO",
      "event_integration_calendar" : "ocorrências Criado Ativado a Sistema calendário do qual o utilizador faz parte de também será Criado Ativado este calendário integrado",
      "2way_sync" : "Sincronização de 2 caminhos: Criar Sistema ocorrências De ocorrências reservadas Ativado o calendário integrado PRIMÁRIO",
      "calendars" : "Calendários",
      "google" : "Google",
      "outlook" : "Outlook",
      "check_for_conflicts" : "Marca de verificação para conflitos",
      "choose_accounts_to_connect" : "selecionar a qual a Conta utilizador deseja ligar",
      "payments" : "Pagamentos",
      "stripe" : "Stripe",
      "ads" : "Anúncios",
      "local_service_ads" : "Anúncios de serviço local",
      "fire_workflow" : "Fluxo de trabalho Acionadores para ocorrências reservadas Via Sincronização bidirecional",
      "connect_google_outlook" : "Ligue a sua Conta Google/Outlook/iCloud para poder selecionar o calendário PRIMÁRIO.",
      "execute_automation" : "Executar a automatização",
      "save" : "Arquivo",
      "lsa" : "Anúncios de serviço local",
      "no_write_access" : "utilizador não escreva Acesso a este calendário",
      "connection_remove_confirmation" : "utilizador're Acerca de para Extrair esta Integração",
      "active" : "Dinâmico",
      "icloud" : {
        "title" : "Integração iCloud",
        "description" : "A autenticação de dois fatores e uma password específico da aplicação são necessários para ligar a sua conta.",
        "email" : "Endereço de e-mail iCloud",
        "password" : "Senha iCloud",
        "connect" : "Ligar",
        "cancel" : "Cancelar"
      }
    }
  },
  "appointment_modal" : {
    "select_a_contact" : "Selecionar um Contacto",
    "start_time" : "Dados de início",
    "unassigned" : "Não atribuído",
    "end_time" : "Dados Fim",
    "search_by_name_email_phone_or_company" : "Pesquisar Via nome, E-mail, Telefone Ou Empresa",
    "add_new" : "Adicionar novo",
    "pick_from_available_contacts" : "Ou selecionar De Amigos disponíveis",
    "book_appointment" : "Marcar um Compromisso",
    "add_blocked_off_time" : "Adicionar dados bloqueados desativado",
    "recommended_timezones" : "Fusos horários Recomendado",
    "all_timezones" : "todos os fusos horários",
    "calendar" : "Calendário",
    "repeat" : "Repetir",
    "date_and_time" : "Dados e Dados",
    "close" : "Fechar",
    "team_member" : "Grupo Membros",
    "recurring_booking" : "Reserva Recorrente",
    "one_slot_booking" : "Uma posição, período Reserva",
    "event_type" : "Tipo de evento",
    "occurrences_booked" : "as ocorrências serão marcadas",
    "repeats" : "Repetições",
    "booking_details" : "Detalhes da reserva",
    "showing_slots_in_this_timezone" : "Períodos de apresentação in fuso horário:",
    "update_contact_tz" : "Também atualize o fuso horário de Contacto para",
    "date" : "Data",
    "slot" : "posição, período",
    "calendar_default" : "Calendário Predefinição",
    "custom" : "Personalizado",
    "meeting_notes" : "(por exemplo) Notas da Conferência para o nosso próximo Compromisso",
    "out_of_office" : "(por exemplo) De escritório para a Semana!",
    "standard" : "Predefinição",
    "appointment_title" : "Título do Compromisso",
    "event_title" : "Título do Evento",
    "appt_with_bob" : "(ex) Compromisso com Bob",
    "vacation" : "(ex) férias",
    "show_notes" : "Mostrar notas",
    "hide_notes" : "Ocultar Notas",
    "additional_preferences" : "Definições adicionais",
    "meeting_location" : "Conferência Localização",
    "appointment_status" : "Estado da Compromisso",
    "appt_description" : "Descrição do Compromisso",
    "recurring_details" : "Detalhes Recorrente",
    "event_description" : "Descrição do Evento",
    "in_contact_timezone" : "in fuso horário do contacto",
    "vacation_message" : "Vai de férias no Ativado? A captar alguns dados Desativado? Bloquear Dados Desativado Ative o seu calendário para evitar que Clientes De marquem o Compromisso Atual O compromisso continuará a ser Ativado o seu calendário).",
    "contact" : "Contacto",
    "delete" : "Eliminar",
    "cancel" : "Cancelar",
    "back" : "Voltar",
    "pick_available_contacts" : "Ou selecionar De Amigos disponíveis",
    "no_contacts_found" : "Nenhum Amigo encontrado",
    "found" : "encontrado",
    "select_one" : "Selecionar um",
    "tz_tooltip" : "Isso é importante apenas Se utilizador're Via valores personalizados; tais como Compromisso Compromisso Compromisso etc. in sua de saída Comunicação com os seus Clientes Ou Clientes. E o que ele simplesmente faz é converter os Detalhes acima mencionados nos seus Dados locais.",
    "meeting_location_tooltip" : "A Conferência Localização será Coleção conforme configurado in calendário.",
    "appt_meeting_location_tooltip" : "O Utilizador pode Coleção a Conferência Localização específico para o Compromisso.",
    "gmeet_tooltip" : "Crie certeza de que o respetivo Grupo Membros tem um Calendário Google Coleção como seu calendário PRIMÁRIO",
    "zoom_tooltip" : "Criar certifique-se de que os respetivos Grupos Membros têm Zoom integrado",
    "enter_meeting_location" : "Insira o Localização da Conferência",
    "save_appointment" : "Arquivo Compromisso",
    "save_event" : "Arquivo Evento",
    "search_contacts" : "Pesquisar Via nome, E-mail, Telefone Ou Empresa",
    "recurring_slots" : "{recurringSlotsLength}/{count}",
    "custom_timezone" : "Fuso horário Personalizado",
    "system_timezone" : "Fuso horário do Sistema",
    "contact_timezone" : "Fuso horário de Contacto",
    "account_timezone" : "Fuso horário da Conta",
    "an_error_occurred" : "Ocorreu um erro"
  },
  "popup" : {
    "calendar" : "Calendário",
    "appointment_owner" : "Proprietário do Compromisso",
    "source" : "Fonte",
    "booked_by" : "Reservado Via",
    "view_activity_log" : "Ver Registo de atividades",
    "status" : "Estado",
    "cancel_appointment" : "Cancelar Compromisso",
    "cancel_all" : "Cancelar todos",
    "google_event" : "Evento Google",
    "outlook_event" : "Outlook Evento",
    "blocked_slot" : "Posição bloqueada, período",
    "appointment" : "Compromisso",
    "confirmed" : "Confirmado(a)",
    "unconfirmed" : "Não confirmado",
    "cancelled" : "Cancelado",
    "showed" : "Mostrado",
    "no_show" : "Não comparência",
    "invalid" : "Inválido(a)",
    "more" : "Mais",
    "less" : "Menos",
    "edit" : "Editar",
    "reschedule_all" : "Reagendar todos",
    "guests" : "Convidado(s)",
    "guest_count" : "Contagem de Convidado"
  },
  "create_calendar" : {
    "calendar_name" : "Nome do calendário",
    "calendar_logo" : "Logótipo do calendário",
    "select_team_member" : "Selecionar Grupo Membros",
    "select_single_team_member" : "Selecionar membro da equipa",
    "eg_outbound_reach" : "(por exemplo) Alcance de saída",
    "description" : "Descrição",
    "amount" : "Montante",
    "description_placeholder" : "Escreva a descrição",
    "meeting_duration" : "Duração da reunião",
    "meeting_location" : "Local da reunião",
    "seats_per_class" : "Assentos por Aula",
    "group" : "Grupo",
    "custom_url" : "URL Personalizado",
    "meeting_invite_title" : "Convite de Conferência Título",
    "event_color" : "Cor do Evento",
    "availability_type" : "Tipo de Disponibilidade",
    "new_calendar" : "Calendário novo",
    "add_description" : "Adicionar descrição",
    "remove_description" : "Extrair Descrição",
    "booking_availability" : "Disponibilidade de reserva",
    "slug_tooltip" : "Personalizar o URLdo Widget de marcações",
    "meeting_location_tooltip" : "Os links de Conferência são Mostrados in Calendário ocorrências como a 'Conferência Localização' e Ativar utilizador para Incluir coisas Gosto links de Zoom para o Evento.",
    "advanced_settings" : "Definições avançadas",
    "show_more_schedule" : "Mostrar mais",
    "show_more_helper_text" : "Para personalizar ainda mais o seu horário de funcionamento, aceda às configuração avançadas",
    "reschedule_preference" : "Reagendar Preferência",
    "reschedule_preference_subtext" : "Se um {contactLabel} reagendar um compromisso:",
    "reassign_through_round_robin" : "Reatribuir a Via Distribuição sequencial",
    "keep_same_assinged_user" : "Manter o mesmo Compromisso Proprietário",
    "new_appointment_preference" : "novo Compromisso Preferência",
    "new_appointment_preference_text" : "Marque sempre com o utilizador atribuído do {contactLabel}",
    "new_appointment_preference_subtext" : "Marque novos compromissos com o utilizador atribuído do {contactLabel} em vez de usar a distribuição sequencial.",
    "cancel" : "Cancelar",
    "confirm" : "Confirmar",
    "service_calendar_name" : "Nome do serviço",
    "service_logo" : "Logótipo do serviço",
    "service_select_team_member" : "selecionar Pessoal Membros",
    "service_duration" : "Duração do serviço",
    "appointment_invite_title" : "Título do convite para o Compromisso",
    "payment_placeholder" : "Insira uma Descrição que será exibida ao Utilizador, informando-o Acerca do pagamento",
    "deposit_amount" : "Montante do Detentor",
    "collect_deposit_amount" : "Aceite pagamento incompleto",
    "percentage" : "Percentagem",
    "total_amount" : "Montante Total",
    "enter_meeting_location" : "Insira o local da reunião",
    "accept_payments" : "Aceitar pagamentos",
    "aria" : {
      "should_accept_payment" : "Deve aceitar pagamento"
    },
    "calendar_name_tooltip" : "Nome do calendário a ser apresentado Ativado o Widget de marcações",
    "booking_availability_tooltip" : "Coleção os dias e hora durante os quais as marcações podem ser feitas. Estas são a sua Predefinição Semanal Negócio hora Mostrado para o Utilizador Ao selecionar uma Janela de tempo",
    "select_team_member_tooltip" : "selecionar o Grupo Membros(s) que participarão desta Conferência",
    "seats_per_class_tooltip" : "Coleção do Número Máximo de Membros permitidos para Marcar esta Aula. Depois de todos os Assentos serem preenchidos, a Janela de tempo não estará mais disponível para reserva",
    "meeting_color" : "Conferência Cor",
    "meeting_duration_tooltip" : "Esta Fixo o Comprimento da sua Conferência, determinando quanto tempo será a última"
  },
  "calendar_advanced" : {
    "general" : {
      "quick_tip" : "Dica rápida",
      "timezone_change_tip" : "As fusos de dados podem ser Dinâmico a qualquer momento em Definições de zona de dados",
      "save" : "Arquivo",
      "close" : "Fechar",
      "meeting_details" : "Conferência Detalhes",
      "availability" : "Disponibilidade",
      "forms_and_payment" : "Formulários e pagamento",
      "notifications_and_additional_options" : "Lembrete e opções adicionais",
      "connections" : "Conexões",
      "customizations" : "Personalizações",
      "create" : "Criar",
      "edit" : "Editar",
      "equipments" : "Quarto & Equipamento",
      "service_details" : "Detalhes do serviço",
      "saving_changes" : "Só um minuto — A guardar... o último Dinâmico...",
      "calendar_id": "Id do calendário",
      "saveCalendarSuccess": "Calendário guardado com sucesso"
    },
    "meeting_details" : {
      "meeting_location" : "Conferência Localização",
      "enter_meeting_location" : "Insira a localização da Conferência",
      "click_to_upload" : "clicar para Carregar",
      "square" : "Quadrado",
      "circle" : "Círculo",
      "remove_logo" : "Extrair Logótipo",
      "meeting_invite_title_tooltip" : "Este é o Título para a Conferência de calendário que Mostrado in seus Compromissos Vista de lista, Calendário Ver e Calendários de terceiros",
      "event_color_tooltip" : "selecionar uma Cor para esta reserva Evento. As cores são sincronizadas com as ocorrências in Calendário Google.",
      "enter_a_name" : "Introduzir um nome",
      "enter_an_event_title" : "Insira um Título de Evento",
      "high_priority" : "High Prioridade",
      "medium_priority" : "Prioridade Médio",
      "low_priority" : "Baixa Prioridade",
      "priority" : "Prioridade",
      "custom" : "Personalizado",
      "zoom_not_added" : "O Utilizador ainda não uniu a sua Conta Zoom",
      "opt_avail" : "Otimizar para Disponibilidade",
      "opt_equal" : "Otimizar para entrega igual",
      "team_members" : "Selecionar Grupo Membros",
      "team_members_location" : "Selecionar Grupo Membros & Atribuir Conferência Localização",
      "team_member" : "Selecionar Grupo Membros",
      "team_member_location" : "Selecionar Grupo Membros & Atribuir Conferência Localização",
      "meeting_location_required" : "Conferência A localização é necessária",
      "meeting_details" : "Conferência Detalhes",
      "meeting_details_description" : "Estas são os Detalhes que serão Mostrados in Lista Página de calendário.",
      "or_drag_and_drop" : "Ou Arrastar e soltar",
      "service_details" : "Detalhes do serviço",
      "team_member_disabled_recurring_tooltip" : "Reuniões recorrentes Ativar apenas um Grupo Membros. Para Incluir vários Membros do Grupo, Desativar Reuniões recorrentes.",
      "team_member_disabled_class_booking_tooltip" : "Apenas um Grupo Membros pode ser adicionado a uma Aula Calendário de serviços",
      "advanced_settings" : "Definições avançadas",
      "enable_contact_assigned_to_setting" : "Para Ativar esta Definição, o Formulário deve estar em primeiro lugar in Widget Ordenar. Reagendar o Widget Ordenar De o separador Formulários e pagamento.",
      "reschedule_preference_setting_tooltip" : "Escolha a quem o compromisso deve ser atribuído quando um {contactLabel} reagendar a partir do widget de marcações.",
      "appointment_preference_tooltip" : "Escolha se os novos compromissos devem ser sempre marcados com o utilizador atribuído do {contactLabel}. Se um {contactLabel} tiver um utilizador atribuído, esse utilizador terá preferência; caso contrário, será uma distribuição sequencial. Dica: desative a opção \"Permitir seleção de equipa\" para evitar que os responsáveis pelas marcações alterem o membro da equipa no widget de marcações.",
      "add_location" : "Adicionar Localização",
      "multiple_locations_neo" : "Vários Endereços de Conferência são suportados apenas Via do Neo Widget.",
      "make_owner" : "Criar Proprietário",
      "only_one_team_member" : "Apenas um Grupo Membros é permitido quando vários Endereços são adicionados.",
      "ask_the_booker_error_message" : "Perguntar ao Responsável pelas marcações A localização já existe",
      "enter_location" : "Introduzir Valor da Localização",
      "enter_display_label" : "Introduzir etiqueta de Ecrã, visualização",
      "add_display_label" : "Adicionar etiqueta de Ecrã, visualização",
      "multiple_location_support_message" : "Vários Endereços de Conferência são suportados apenas Via do Neo Widget.",
      "only_one_team_member_personal_calendar" : "Apenas um Grupo Membros é permitido para reserva pessoal ",
      "ms_teams_not_added" : "O Utilizador ainda não ligara a sua Conta do Grupo Microsoft",
      "enable_new_appt_preference" : "Ativar novo Compromisso Preferência",
      "enable_new_appt_preference_desc" : "A ativação da opção &quot;<b>Marcar sempre com o utilizador atribuído do {contactLabel}</b>&quot; irá definir automaticamente o <b>formulário</b> como o primeiro passo na ordem do widget.",
      "location_exists_toast" : "Conferência Localização já adicionada",
      "not_supported_with_multiple_team_members" : "Não suportado com vários Membros do Grupo",
      "not_supported_personal_calendar" : "Não suportado in calendário pessoal",
      "not_supported_class_booking" : "Não suportado in Aula Calendário de serviços",
      "not_supported_collective_booking" : "Não suportado in calendário COLETIVO",
      "not_supported_service_booking" : "Não suportado in Calendário de serviços",
      "not_supported_round_robin" : "Não suportado in calendário sequencial da distribuição",
      "not_supported_event" : "Não suportado in calendário de eventos",
      "calendar_logo_tooltip" : "selecionar um Logótipo para ser Mostrado Ativado o Widget de marcações",
      "calendar_name_tooltip" : "Nome do calendário a ser apresentado Ativado o Widget de marcações",
      "description_tooltip" : "Descrever o que é o calendário Acerca de, a ser apresentado Ativado o Widget de marcações",
      "group_tooltip" : "o utilizador pode atribuir este calendário a um Grupo (Se Criado). O utilizador Acesso ao Grupo Ligar, vincular pode pesquisar e Marcar De todos os calendários in Grupo",
      "custom_url_tooltip" : "Personalizar o URLdo Widget de marcações",
      "meeting_color_tooltip" : "selecionar uma Cor para esta reserva Evento. As cores fornecem Sincronização para Eventos in Calendário Google",
      "add_display_label_tooltip" : "Para mascar a Localização caso várias Configurações Opções estejam disponíveis",
      "meeting_location_tooltip" : "selecionar como Ou para onde a Conferência irá demorar Localização",
      "team_members_location_tooltip" : "selecionar os Grupo Membros que participarão desta Conferência",
      "meeting_distribution" : "Conferência Entrega",
      "meeting_distribution_tooltip" : "selecionar como os Compromissos são distribuídas nos seus Selecionado Grupo Membros — com base Ativado Disponibilidade Ou igual Entrega",
      "opt_avail_tooltip" : "Atribua conversas aos Membros do Grupo que está disponível nos Dados Selecionados, inde- pendente das marcações anteriores. Máximo da posição de abertura, utilização do período e reserva Sucesso Frequência",
      "opt_equal_tooltip" : "Publicar compromissos Igualmente entre todos os Grupo Membros Via rastreio de marcações anteriores. Prioriza a equidade sobre a Disponibilidade",
      "priority_tooltip" : "Coleção a Preferência Uniforme para atribuir compromissos Quando estão disponíveis vários Grupos Membros. Os Membros de maior Prioridade serão consideradas primeiro para marcações, Seguir Via Médio e Membros de baixa Prioridade",
      "contact_routing_preference" : "Preferência de reencaminhamento de Contacto",
      "contact_routing_preference_tooltip" : "Defina como {contactsLabel} novos e que regressam são atribuídos aos membros da equipa: por distribuição sequencial ou pelo respetivo proprietário original",
      "team_members_location_owner_tooltip" : "O PRIMÁRIO Utilizador proprietário da Conferência e que fornecem a Conferência final Localização",
      "owner" : "Proprietário",
      "upload_from_system" : "Carregar a partir do sistema",
      "choose_from_media_storage" : "Escolher a partir do armazenamento de multimédia",
      "only_one_team_member_allowed" : "Apenas um membro da equipa é permitido",
      "at_least_two_team_members_required" : "São necessários pelo menos 2 membros da equipa",
      "at_least_one_team_member_required" : "É necessário pelo menos um membro da equipa"
    },
    "availability" : {
      "my_availability" : "A minha disponibilidade",
      "set_availability" : "Coleção a sua Disponibilidade para o calendário aqui.",
      "standard" : "Padrão",
      "custom" : "Personalizado",
      "to" : "Para",
      "copy_to_all" : "Copiar para todos",
      "add_time" : "Adicionar dados",
      "recurring_meeting" : "Conferência Recorrente",
      "recurring_info" : "Apenas um Utilizador por calendário para reserva Recorrente",
      "repeat" : "Repetir",
      "times_to_repeat" : "vezes para Repetir",
      "slots_unavailable" : "Se os períodos não estiverem disponíveis?",
      "overlap_status" : "Estado do Compromisso para períodos sobrepostos ",
      "meeting_interval" : "Intervalo da reunião",
      "meeting_duration" : "Duração da reunião",
      "minimum_scheduling" : "Mínimo agendar AVISO",
      "date_range" : "Intervalo de datas",
      "maximum_bookings_per_day" : "Máximo de marcações por Dia",
      "maximum_bookings_per_slot" : "Máximo de marcações por posição, período",
      "maximum_bookings_per_slot_per_user" : "Máximo de marcações por intervalo (por utilizador)",
      "seats_per_class" : "Assentos por Aula",
      "pre_buffer_time" : "Tempo de buffer prévio",
      "post_buffer_time" : "Tempo de buffer posterior",
      "pre_buffer_tooltip" : "O pré-cupão são dados adicionais que podem ser adicionados antes de um compromisso, Ativar para dados extras para obter o Pronto",
      "post_buffer_tooltip" : "O Pós- Memória intermédia são dados adicionais que podem ser adicionados Depois de um compromisso, Ativar para dados extras para finalizar",
      "buffer_time" : "Memória intermédia Dados",
      "daily" : "diário",
      "weekly" : "Semanal",
      "monthly" : "Mensal",
      "skip_booking" : "Ignorar a reserva de períodos não disponíveis",
      "continue_booking" : "Continuar a marcar",
      "book_next_available" : "Marcar Seguinte disponível posição, período",
      "confirmed" : "Confirmado(a)",
      "unconfirmed" : "Não confirmado",
      "enter_valid_hours" : "Insira uma hora Abrir válida",
      "enter_valid_avail" : "Insira uma Disponibilidade Personalizada válida",
      "availability_type_tooltip" : "Selecionar Padrão Disponibilidade para marcações Mensal ofertas Semanal. Selecionar Personalizado para marcações disponíveis apenas em datas específicas do Ativado.",
      "meeting_interval_tooltip" : "A Conferência Segundos mostra a quantidade de Dados entre os períodos de reserva que será Mostrado in calendário. Para um Evento de 30 Mínimo que deve estar disponível no Topo de todas as horas, os Segundos serão de 1 hora. Para um Evento de 30 Mínimo que deve estar disponível todos os 30 minutos, os Segundos serão de 30 minutos.",
      "date_range_tooltip" : "as ocorrências podem ser Agendadas ao longo dos Seguintes n dias.",
      "maximum_bookings_per_day_tooltip" : "Número máximo de compromissos permitidos por Dia Ativado este calendário",
      "maximum_bookings_per_slot_tooltip" : "Máximo número de compromisso permitido por posição, período para o utilizador (Se o número de compromisso exceder para a posição determinada, período para o utilizador, Depois ou troca para o seguidor utilizador in fila sequencial de distribuição ou marca de água a posição, período não disponível para o Oportunidade a Marcar).",
      "add_days" : "Adicionar dias",
      "month_on_day" : "Mensal ativado dia",
      "month_on_last_day" : "Mensal ativado último",
      "day" : "Dia",
      "week" : "Semana",
      "month" : "Mês",
      "mins" : "Minutos",
      "hours" : "Horas",
      "days" : "Dias",
      "weeks" : "Semanas",
      "months" : "Meses",
      "meeting_interval_error" : "A Conferência Segundos deve ter entre 5 minutos e 12 horas",
      "meeting_duration_error" : "A duração da reunião deve estar entre 1 mínima e 12 horas",
      "buffer_time_error" : "Memória intermédia Os dados devem ter menos de 12 horas",
      "appointment_interval" : "Compromisso Segundos",
      "appointment_duration" : "Duração do Compromisso",
      "maximum_appointments_per_day" : "Máximo Compromisso por Dia",
      "subTitle" : "selecionar os Dados para a Hora específica da Coleção",
      "heading_1" : "Horas disponíveis Semanal",
      "scheduling_availability_heading" : "Disponibilidade de Reservas",
      "tooltip_1" : "Coleção a sua agenda Semanal Disponibilidade. Estas são as suas horas Padrão que serão aplicadas de forma consistência Ativado a Semanal",
      "heading_2" : "Quando o utilizador está disponível?",
      "unavailable_label" : "Não disponível",
      "tooltip_2" : "Modifique a sua agenda para datas específicas. Substituir a sua hora Mensal Semanal Via a marcação Disponibilidade Ou indisponibilidade para datas Selecionadas.",
      "date_specific_level" : "Adicionar dados específicos hora",
      "specific_hours_button" : "Horas específicas da Data",
      "specific_hours_description" : "Substitua a sua disponibilidade por datas específicas quando as suas horas diferirem das suas horas semanais normais.",
      "overlap_error" : "Os períodos de dados não podem SOBREPOSIÇÃO",
      "apply" : "Aplicar",
      "copy_times_to" : "Copiar vezes para",
      "no_date_specific_heading" : "Nenhum dado específico adicionado",
      "no_date_specific_description" : "o utilizador pode Incluir/ Extrair Dados específicos e Dados para a sua Disponibilidade",
      "recurring_disabled_conditions_tooltip" : "Reuniões recorrentes são Desativado. Para os acionador, certifique-se de que o calendário tem apenas um Grupo Membros e não tem uma hora ou pagamento incompleto específico adicionado.",
      "date_specific_hours_disabled_conditions_tooltip" : "Para Incluir uma hora definida por uma data, certifique-se de que as Reuniões Recorrentes estão Desativadas.",
      "recurring_disable_event_calendar_conditions" : "Reuniões recorrentes são Desativado. Para acionador, certifique-se de que nenhum pagamento de hora ou incompleto específico em data foi adicionado.",
      "service_duration" : "Duração do serviço",
      "service_interval" : "Segundos de serviço",
      "service_interval_tooltip" : "A Conferência Segundos Fixo com que frequência os períodos de reserva aparecem Ativado o calendário. Para o Modelo, para um Evento de 30 minutos, um Segundos de 1 hora significa que os períodos aparecem todas as horas.A 30-minuto Segundos significa que os períodos aparecem todos os 30 minutos.",
      "service_duration_tooltip" : "Fixo este comprimento do seu compromisso, determinando quanto tempo será o último.",
      "minimum_scheduling_tooltip" : "Esta Fixo os Mínimo Dados Necessário para Marcar um Compromisso Via o Widget de calendário . Para o Modelo, Se Coleção para 4 horas, o Compromisso não pode ser reservado dentro de 4 horas da sua Data de início; as marcações devem ser feitas com pelo menos 4 horas in antecedência.",
      "look_busy_title" : "Parecer ocupado",
      "look_busy_helper_text" : "Ocultar uma Percentagem dos seus Períodos de compromisso disponíveis Ativado o Widget de marcações para parecer mais ocupado e in grande procura",
      "look_busy_percentage_description" : "Ocultar o número de períodos disponíveis Via x%",
      "maximum_bookings_per_slot_tooltip_personal" : "Limitar quantos compromissos podem ser Agendados para a mesma Janela de tempo",
      "enable_recurring_title" : "Conferência Ativar Recorrente",
      "enable_recurring_desc" : "Rodar <b>Reuniões Ativado Recorrente</b> irá Desativar automaticamente as Definições à direita, uma vez que não podem existir:",
      "date_specific_hours" : "todas <b>as horas em datas específicas</b> serão eliminadas.",
      "multiple_team_members" : "<b>Vários Membros do Grupo</b> serão com subscrição anulada — apenas um Membros do Grupo pode permanecer in calendário.",
      "partial_payments" : "<b>Os Pagamentos Incompleto</b> serão Desativado, e o montante Completo será cobrado.",
      "select_team_member_to_keep" : "selecionar a Grupo Membros para Manter in calendário:",
      "select_team_member" : "Selecionar Grupo Membros",
      "partial_payments_disabled" : "Uma vez que os Pagamentos incompleto serão Desativado, como poderá o utilizador Gosto cobrar o montante do Completo para o Recorrente Compromisso?",
      "enable_date_specific_hours" : "Ativar horas específicas da Data",
      "enable_date_specific_hours_desc" : "Rodar <b>as horas específicas de data</b> Ativado irá Desativar automaticamente a Definição à direita, uma vez que não podem existir:",
      "recurring_meetings_disabled" : "<b>Reuniões recorrentes serão desativadas</b>, {contactsLabel} só poderá marcar compromissos individuais com base nas datas disponíveis que definiu.",
      "payment_preference" : "Preferência de pagamento:",
      "team_members_in_this_calendar" : "Grupo Membros in calendário",
      "other_team_members" : "Outros Grupo Membros (Não adicionado a este calendário)",
      "select_team_member_tooltip" : "selecionar o Grupo Membros(s) que participarão desta Conferência",
      "meeting_duration_tooltip" : "Esta Fixo o Comprimento da sua Conferência, determinando quanto tempo será a última",
      "date_specific_hours_tooltip" : "Modifique a sua agenda para datas específicas. Substituir a sua hora Mensal Semanal Via marcação Disponibilidade Ou indisponibilidade para datas Selecionadas",
      "recurring_meeting_tooltip" : "Ativar eventos para Repetir várias vezes ao longo de uma Semana",
      "repeat_frequency_tooltip" : "selecionar a Frequência deste Evento recorrente",
      "time_to_repeat_tooltip" : "Coleção do número Total de Repetições",
      "slots_unavailable_tooltip" : "selecionar o que deve acontecer Selecionar uma Ou mais Os períodos de dados in reserva Recorrente já estão marcados",
      "skip_booking_tooltip" : "Apenas os períodos disponíveis serão marcados. Todas as datas não disponíveis in série Recorrente serão ignoradas",
      "force_book" : "Forçar Marcar",
      "force_booking_tooltip" : "todas as horas serão reservadas, Uniforme Se Lá é um Conflito. Utilizar com cuidado para evitar marcações duplas",
      "book_next_available_tooltip" : "Se a posição Selecionado, o período não está disponível, Marcar o Seguinte disponível posição, período Ativado a mesma agenda Recorrente (por exemplo, Seguinte Segunda-feira Se Semanal)",
      "slot_interval_tooltip" : "Coleção o intervalo entre as horas de início de períodos disponíveis seguidos. Para o Modelo, se a duração da sua Conferência é de 30 minutos e a Coleção dos Segundos é utilizada para 60 minutos, um Utilizador pode Marcar às 9:00 AM, Depois 10:00 AM, e assim Ativado — Uniforme embora todas as Conferências durem apenas 30 minutos",
      "minimum_scheduling_notice_tooltip" : "Necessário Utilizador para Marcar Reuniões pelo menos esta quantidade de Dados in",
      "date_range_preferences_tooltip" : "Coleção até quando as marcações futuras podem ser feitas Dados de Hoje",
      "maximum_bookings_per_slot_preferences_tooltip" : "Limitar quantos compromissos podem ser Agendados para a mesma Janela de tempo",
      "maximum_bookings_per_slot_per_user_preferences_tooltip" : "Limitar o número de compromissos que podem ser Agendados para a mesma Janela de tempo (por Utilizador)",
      "pre_buffer_time_tooltip" : "Dados para bloquear Antes de todos a Conferência, Ativar para Dados extras para preparar",
      "post_buffer_time_tooltip" : "Dados para bloquear Depois de todos a Conferência, Ativar para dados extras para finalizar",
      "seats_per_class_tooltip" : "Coleção do Número Máximo de Membros permitidos para Marcar esta Aula. Depois de todos os Assentos serem preenchidos, a Janela de tempo não estará mais disponível para reserva",
      "maximum_bookings_per_slot_per_user_tooltip" : "Limitar o número de compromissos que podem ser Agendados para a mesma Janela de tempo (por Utilizador)",
      "repeat_frequency" : "Frequência de Repetir",
      "slot_interval" : "posição, período Segundos",
      "skip_booking_helper_text" : "Apenas os períodos disponíveis serão marcados. Todas as datas não disponíveis in série Recorrente serão ignoradas",
      "force_book_helper_text" : "todas as horas serão reservadas, Uniforme Se Lá é um Conflito. Utilizar com cuidado para evitar marcações duplas",
      "book_next_available_helper_text" : "Se a posição Selecionado, o período não está disponível, Marque o Seguinte disponível, período Ativado a mesma agenda Recorrente (por exemplo, Seguinte Segunda-feira Se Semanal).",
      "bulk_edit" : "Edição em massa",
      "select_users" : "Selecionar utilizadores",
      "select_all" : "Selecionar Todos",
      "times_to_repeat_tooltip" : "Coleção a soma de Contagem de Repetições"
    },
    "forms_payment" : {
      "forms" : "Formulários",
      "forms_sub" : "Coleção pós-agenda Formulário Definições.",
      "select_form" : "selecionar Formulário",
      "enable_same_user_assignment" : "Atribuir Amigos ao seu respetivo calendário Grupo Membros todos Data um Compromisso está marcado",
      "sticky_contacts" : "Pré-preencher Campos (fixo Amigos)",
      "confirmation_page" : "Página de confirmação",
      "default" : "Predefinição",
      "redirect_url" : "URL de redirecionamento",
      "thank_you" : "Agradecer ao utilizador Mensagem",
      "enter_url" : "Introduza o URL",
      "amount_tab_hidden_label" : "Marcador de posição da aba de montante",
      "percentage_tab_hidden_label" : "Marcador de posição da percentagem",
      "pixel_id" : "Meta Id do pixel (Opcional)",
      "auto_confirm" : "Confirmar automaticamente novo compromissos de calendário",
      "configure_payment" : "Configurar pagamentos Opções",
      "accept_payments" : "Aceite pagamentos",
      "test" : "Testar",
      "live" : "Em direto",
      "enable_guests" : "Adicionar Convidados",
      "add_guest_tooltip" : "Adicionar Convidado irá Ativar o seu Convidado para Incluir vários participantes ao mesmo Compromisso",
      "add_guest_custom_form_tooltip" : "Habilitar esta opção irá Carregar um e-mail gerada pelo sistema para os hóspedes com um Ligar, vincular ao Formulário Personalizado assim que o seu Compromisso estiver Confirmado. Para evitar a duplicação Gmail, certifique-se de que um e-mail de confirmação separado ainda não esteja Configure para os hóspedes. ( Verifique isto in separador Lembrete > Notificação de Confirmação)",
      "add_guest_same_form_check" : "Carregar o mesmo Formulário para cobrar Detalhes Por e-mail para todos os convidados",
      "payment_tooltip" : "O pagamento só seria considerada para o PRIMÁRIO Convidado e não para os convidados.",
      "default_form" : "Predefinição (Primário nome, último nome, E-mail, Telefone, Notas)",
      "select_form_tooltip" : "O utilizador teria Gosto de juntar mais Detalhes do que o Padrão Nome próprio, último Nome, E-mail e Telefone De quem Marcar Ativado este calendário, Criar um Formulário Personalizado in Sites > Formulários > Construtor Depois de selecionar o Formulário Via o Menu suspenso abaixo .",
      "confirmation_page_tooltip" : "Depois de alguém fazer uma reserva, o utilizador pode selecionar para mostrar-lhe uma mensagem personalizada ativado a mesma página (predefinição) ou redirecionar para uma página de sua escolha (redirecionamento).",
      "add_guest_collect_email" : "Nome e e-mail",
      "add_guest_count_only" : "Apenas Contagem",
      "custom_email_notification" : "Carregar Formulário Personalizado para Convidados",
      "consent_label" : "Caixa de verificação de Consentimento",
      "consent_input_placeholder" : "Adicionar Consentimento Corpo",
      "same_user_assignment_tooltip" : "Para Ativar esta Definição, o Formulário deve ser primeiro Ativado o Widget. Reagendar o Widget para o Estado o Formulário primeiro para acionador esta Definição.",
      "consent_tooltip" : "Ative esta opção para permitir a obtenção de consentimento de {contactsLabel} quando este fornece o número de telefone durante o processo de marcação de um compromisso.",
      "stripe_error" : "Até duas casas decimais ( Modelo: 25.99)",
      "auto_confirm_service" : "Confirmar automaticamente novo compromisso",
      "service_form_message" : "Se um Contacto estiver a agendar vários Serviços, ele apenas verá o Formulário de Predefinição in menu de serviço",
      "deposit_amount_error" : "O valor do depósito tem de ser inferior ao montante Total .",
      "deposit_percentage_error" : "A percentagem do depósito tem de ser menor que 100%.",
      "partial_payment_tooltip" : "Ativar Pagamentos incompleto para cobrar o valor do depósito De Clientes durante o Compromisso de reserva Fluxo de trabalho",
      "partial_payment_enable_error" : "O Montante Total introduzida tem de ser maior que 0 para pagamentos Ativar Incompleto.",
      "payment_disable_text_integration" : "Integre um fornecedor de pagamento em Pagamentos > Integrações para começar a aceitar pagamentos",
      "payment_disable_text_recurring" : "A opção Aceite o pagamento não está disponível para as Reuniões Recorrente. Desativar Recorrente para pagamentos Ativar.",
      "date_and_time_selector" : "Dados e selecionador de dados",
      "form_selector" : "Formulário",
      "order_step" : "Passo",
      "widget_order_label" : "Widget Ordenar",
      "widget_order_tool_tip" : "Reagendar os \"Dados e o Seletor de Dados\" e o \" Formulário \" Ordenar Ativado o Widget de calendário . Simplesmente Arrastar e reordenar pela sua Preferência.",
      "widget_re_order_tooltip" : "A reordenação só está disponível com o estilo do Widget Neo . Mudar para a reordenação Neo para Ativar.",
      "widget_re_order_disabled_tooltip" : "Para reorganizar a ordem do widget, desative \"Nova preferência de compromisso (marcar sempre com o utilizador atribuído do {contactLabel})\" na secção Informações da reunião > Membros da equipa > Definições avançadas.",
      "payment_description_error" : "Máximo Caráter SLOTMAX de 1000 atingido",
      "widget_multiple_location_disabled_tooltip" : "O Widget Clássico não suporta vários Endereços de Conferência. Extraia qualquer endereço adicional para utilizar o WidgetClássico",
      "recurring_payment_label" : "Pagamento de Compromisso Recorrente",
      "enable_payments_for_guests" : "Ativar Pagamentos para Convidados",
      "guest_payment_description" : "Uma vez que o utilizador tem Ativado a opção \"Adicionar Convidados\", o utilizador também pode selecionar para custo por Convidado Quando de reserva.",
      "charge_per_attendee" : "custo por Convidado",
      "charge_per_attendee_description" : "Multiplicar o montante Total Via o número de participantes (incluindo convidados) Ao cobrar o pagamento durante a reserva.",
      "click_confirm_description" : "Clique em guardar para aplicar estas alterações.",
      "multiply_amount_guests" : "Recolher o pagamento de todos os participantes",
      "multiply_amount_guests_description" : "Quando Ativado, o valor a ser cobrado durante a reserva será duplicado Via Número Total de participantes, incluindo convidados",
      "first_appointment_only" : "custo apenas para o primeiro compromisso",
      "all_appointments" : "custo para todos Compromisso inicial",
      "no_payment_provider_connected" : "Nenhum pagamento Fornecedor conectado",
      "no_default_payment_provider" : "Nenhum pagamento Fornecedor conectado",
      "provider_not_supported" : "O pagamento de predefinição ao fornecedor não é suportado",
      "manage_payment_provider" : "Gerir Fornecedores de Pagamento",
      "supported_providers" : "Fornecedores suportados",
      "paypal_razorpay_helper_text" : "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order" : "Reagendar Widget Ordenar",
      "change_form_order" : "Dinâmico o Formulário para o segundo Passo in Widget Ordenar irá Desativar a definição à direita:",
      "change_form_order_desc" : "A opção <b>Nova preferência de compromisso (marcar sempre com o utilizador atribuído do {contactLabel})</b> será desativada. Isto significa que os compromissos podem ser marcados com qualquer membro da equipa disponível, em vez de estarem restritos ao utilizador atribuído do {contactLabel}.",
      "enable_mandatory_guest" : "Criar a adição de pelo menos um Convidado Necessário. O Convidado Campos será pré-aberto e deve ser preenchido antes de fazer a reserva.",
      "enable_mandatory_guest_count" : "Tomar o Necessário Convidado Contagem Ativado o Widget de marcações",
      "require_guest_for_booking" : "Convidados necessários para fazer a reserva",
      "sticky_contacts_tooltip" : "Preencher automaticamente campos para {contactsLabel} conhecidos.",
      "auto_confirm_tooltip" : "Marcação automática de novas Reuniões de água como Confirmado sem requerer Aprovação Manual . Desativar este utilizador Se deseja Revisão e confirmar todas as marcações manualmente Antes de ser Agendado",
      "confirm_tooltip" : "Depois de alguém efetuar uma reserva, o utilizador pode selecionar para mostrar-lhe uma mensagem personalizada ativado na mesma página (predefinição) ou redirecionar para uma página de sua escolha (URL de redirecionamento)",
      "facebook_pixel_id_tooltip" : "",
      "accept_payments_tooltip" : "Ativar a Coleção de pagamentos durante as marcações",
      "total_amount_tooltip" : "Coleção do custo Total para a Conferência",
      "deposit_amount_tooltip" : "Montante a cobrar no momento da reserva como um depósito",
      "multiply_amount_guests_all_guests" : "Cobrar o pagamento de todos os participantes, incluindo convidados",
      "multiply_amount_guests_all_guests_tooltip" : "Quando Ativado, o valor a ser cobrado durante a reserva será duplicado Via Número Total de participantes, incluindo convidados",
      "payment_description" : "Descrição do pagamento",
      "payment_description_tooltip" : "Opcionalmente, inclua quaisquer detalhes Acerca do pagamento",
      "test_mode_warning" : "Modo de teste Dinâmico – nenhuma venda real será processada.",
      "pixel_id_tooltip" : "Carregar Widget de marcações Atividade Gosto Visualizações, cliques, e envios para Meta Via o seu Id do pixel",
      "forms_description" : "Configure os Campos e o Fluxo do seu Formulário de reserva",
      "payment_mode" : "Modo de pagamento",
      "payment_mode_tooltip" : "Alterne entre o modo de teste e o modo Em direto para pagamentos. in Modo de teste, não é efetuada nenhuma faturação real — utilize-o para simular o Fluxo de trabalho de reserva e pagamento. Mude para o modo Em direto para aceitar pagamentos atuais De Clientes.",
      "enable_coupon" : "Ativar códigos de cupão",
      "enable_coupon_tooltip" : "Ativar que os Clientes apliquem Códigos de cupão durante a reserva. Para garantir que funcionem, crie primeiro Códigos de cupão válidos em Pagamentos > Códigos de cupão"
    },
    "notifications" : {
      "notifications" : "Lembrete e opções adicionais",
      "notifications_sub" : "Configurar Notificação e Opções adicionais",
      "edit" : "Editar",
      "created_on" : "Criado em",
      "updated_on" : "Atualizado em",
      "delivered" : "Entregue",
      "not_available" : "Não aplicável",
      "select_notification_type" : "selecionar o Tipo de Notificação",
      "notification_person" : "Quem deve Herdar esta Notificação?",
      "contact" : "{contactLabel}",
      "guest" : "Convidado",
      "assigned_user" : "Utilizador atribuído",
      "emails" : "Gmail",
      "alert_email_address" : "Endereço de e-mail de Alerta",
      "ack_email" : "E-mail de Reconhecimento",
      "send_google_invites" : "Ativar Calendário Convite Google para Carregar Ou atualize Gmail para os participantes.",
      "send_google_outlook_invites" : "Permitir que o Google / Calendário do Outlook / Calendário do iCloud envie convites e atualizações de e-mail para os participantes.",
      "assign_user_to_contact" : "Atribuir {contactsLabel} aos membros da equipa de calendário correspondentes cada vez que um compromisso for marcado",
      "skip_assigning_user_to_contact" : "Ignorar a atribuição do {contactLabel} se o {contactLabel} já tiver um utilizador atribuído",
      "assigned_staff" : "Pessoal atribuído",
      "additional_emails" : "Gmailadicional",
      "assign_user_to_staff" : "Atribuir {contactsLabel} aos membros da equipa de serviço correspondentes cada vez que um compromisso for marcado",
      "allow_cancellation" : " Permitir cancelamento de reunião",
      "allow_reschedule" : "Permitir o reagendamento da reunião",
      "allow_cancellation_tooltip" : "Quando Ativado, um Cancelamento Ligar, vincular será adicionado à Secção de notas adicionais e incluído in convite do calendário. Esta Ligar, vincular irá Expirar conforme configurado Antes dos Dados de início da Conferência, impedir o Responsável pelas marcações De cancelar a Conferência.",
      "allow_reschedule_tooltip" : " Quando Ativado, um Ligar de reagendamento, vincular será adicionado à Secção de notas adicionais e incluído in convite de calendário. Esta Ligar, vincular irá Expirar conforme configurado Antes dos Dados de início da Conferência, interrompendo o Responsável pelas marcações De reagendar a Conferência.",
      "cancellation_link_expiry" : "O link de cancelamento expirará",
      "reschedule_link_expiry" : "O link de reagendamento vai expirar",
      "before_meeting" : "Antes da Conferência",
      "cancellation_and_reschedule_policy" : "Política de Cancelamento e Reagendar :",
      "meeting_invite_notes" : "Conferência Convite Notas",
      "meeting_invite_notes_tooltip" : "Adicionar notas que aparecem in convite de calendário enviado aos Clientes. Estas notas serão Sincronização com Calendários de terceiros in Conferência Descrição"
    },
    "connections" : {
      "connections_heading" : "Calendários de terceiros Sincronização",
      "connections_sub" : "Sincronização de ocorrências com Calendários de terceiros",
      "link_to_calendar" : "Ligar, vincular ao calendário",
      "sync_option" : "Opção de Sincronização",
      "execute_automation" : "Executar a automatização",
      "fire_workflow" : "Disparar acionadores de fluxo de trabalho para eventos marcados via sincronização bidirecional",
      "reserve_with_google" : "Marcar com Google [A ser descontinuado]",
      "reserve_with_google_setup" : "Ver Instruções de Configuração",
      "reserve_with_google_configure" : "Configurar",
      "change" : "Alterar",
      "rwg_deprecation_notice" : "Google <strong>descontinuou o Marcar com Google (RwG)</strong>, conhecido como <strong>Serviços Anúncios locais</strong>. novas ligações não são mais suportadas. Para Continuar a receber marcações Via Google, utilize <strong>Marcações orgânicas do Google</strong> .",
      "rwg_category" : "Categoria",
      "rwg_service_type" : "Serviço",
      "connect_lsa" : "Ligue-se aos seus Serviços Conta de anúncios locais",
      "reserve_error" : "agora Marcar com Google é suportado apenas para \"Utilizadores do Lar\", \"Imóvel\", \"Utilizadores\" (Provedores de Serviços locais) Empresa nicho in EUA.",
      "one_way" : "Só direcional",
      "two_way" : "Dois caminhos",
      "smart" : "Inteligente",
      "confirm_remove" : "Tem a certeza de que o utilizador deseja Extrair Calendário Google?",
      "read_only_access" : "o utilizador não tem Acesso de escrita a este calendário. Selecione um calendário diferente.",
      "reserve_with_google_desc" : "Este serviço de calendário será listado in Marcar apenas com Google Ativado Integração bem-sucedido.",
      "check_integration" : "Marca de verificação do seu estado de integração",
      "setup_external" : "Configuração os seus calendários de terceiros",
      "reserve_price_decimal_error" : "O preço decimal não é suportado",
      "reserve_price_max_error" : "Preço suportado menos de 1000",
      "link_to_calendar_tooltip" : "selecionar o calendário com o qual o utilizador pretende Sincronizar este calendário",
      "one_way_sync" : "Sentido Único",
      "default_one_way" : "Sincronização predefinida (sincronização unidirecional)",
      "one_way_sync_desc" : "Os eventos do calendário ligado são sincronizados como horários bloqueados e não são criados contactos para os convidados.",
      "two_way_sync" : "Sincronização bidirecional",
      "two_way_sync_desc" : "São criados contactos para os convidados encontrados em eventos de calendários ligados e estes eventos são transformados em compromissos do sistema.",
      "smart_sync" : "Sincronização Inteligente",
      "smart_sync_desc" : "Os eventos do calendário ligado são sincronizados como compromissos para os contactos existentes. Se não existir nenhum contacto, são sincronizados como intervalos bloqueados sem criar um novo contacto.",
      "sync_option_tooltip" : "Escolha como os eventos do seu calendário externo serão sincronizados com este calendário. Pode bloquear apenas a disponibilidade ou também criar/gerir o {contactsLabel} e compromissos aqui, com base no modo de sincronização que selecionar",
      "one_way_sync_tooltip" : "Blocos Períodos de dados Via importação de Eventos ocupados De seus Calendários de terceiros",
      "two_way_sync_tooltip" : "Importa reuniões e cria o {contactsLabel} e compromissos no sistema. As alterações feitas aqui serão refletidas no calendário externo",
      "smart_sync_tooltip" : "Importa reuniões e cria compromissos apenas se a reunião foi criada por um {contactLabel} conhecido",
      "default_sync" : "Predefinição",
      "default_sync_desc" : "Sincronização de ocorrências do seu calendário externo para este calendário",
      "advanced_sync" : "Avançado",
      "advanced_sync_desc" : "Sincronização de ocorrências do seu calendário externo para este calendário e cria Compromissos e contactos no Sistema",
      "assign_contact_to" : "Atribuir contacto a",
      "select_calendar" : "Selecionar calendário",
      "sync_preferences" : "Preferências de sincronização",
      "sync_preferences_desc" : "Como gostaria de sincronizar os seus eventos do calendário ligado?",
      "recommended" : "Recomendado",
      "execute_automation_desc" : "Executar a automatização quando uma Conferência é Criado neste calendário",
      "save" : "Guardar alterações",
      "cancel" : "Cancelar"
    },
    "extras" : {
      "extras" : "Personalizações",
      "extras_sub" : "Coleção Estilo do Widget e Outros Definições.",
      "calendar_widget_style" : "Estilo do Widget de calendário",
      "neo" : "Novo",
      "classic" : "Clássico",
      "insert_custom_code" : "Inserir código personalizado",
      "show_seats_per_slot" : "Mostrar Assentos por posição, período",
      "allow_reschedule_meeting" : "Ativar Reagendar Conferência",
      "allow_cancelling_meeting" : "Ativar a cancelar Conferência",
      "additional_notes" : "Notas adicionais",
      "cancellation_and_reschedule" : "Cancelamento e reagendado:",
      "allow_staff" : "Seleção do pessoal Ativar durante a reserva",
      "code_block_tooltip" : "scripts de terceiros O interior do bloco HTML pode oferecer funcionalidades poderosas, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Por conseguinte, recomendamos que o utilizador para Rever o conteúdo deste Código Antes de A o guarde... no calendário.",
      "calendar_image" : "Imagem da capa do calendário",
      "remove_image" : "Extrair imagem",
      "calendar_image_info" : "A Imagem enviada estará visível dentro do Grupo Ver para Neo Modelo e não aparecerá Ativado o calendário Individual Ligar, vincular",
      "get_image_from_unsplash" : "Melhore o seu visual com",
      "unsplash" : "Unsplash",
      "service_additional_preferences" : "Configurar definições adicionais",
      "service_image" : "Imagem da capa do serviço",
      "service_image_description" : "selecionar uma Imagem que será Mostrado Ativado o menu Serviços para este serviço",
      "allow_reschedule_appointment" : "Ativar Reagendar Compromisso",
      "allow_cancelling_appointment" : "Ativar a cancelar Compromisso",
      "custom_code_placeholder" : "Por favor, comentários Código personalizado aqui",
      "calendar_widget_style_desc" : "selecionar entre o nosso Clássico Ou o elegante Neo",
      "seats_per_slot" : "Assentos por posição, período",
      "show_staff_selection" : "Seleção de Pessoal",
      "seats_per_slot_desc" : " Ativar Responsável pelas marcações para Ver o número de Assentos disponíveis por Janela de tempo diretamente Ativado o Widget de calendário.",
      "show_staff_selection_desc" : "Ativar Responsável pelas marcações para selecionar uma equipa Membros diretamente Do Widget de calendário durante a reserva de Compromisso. Funciona apenas com Neo Widget",
      "widget_re_order_tooltip" : "O estilo do Clássico Widget não Ativar Widget Ordenar Dinâmico. Certifique-se de que o Selecionador de dados é o primeiro e o Formulário é o segundo Antes de selecionar o estilo Clássico.",
      "show_staff_selection_desc_service" : "Ativar Responsável pelas marcações para selecionar uma equipa Membros diretamente Do Widget de calendário durante a reserva de Compromisso.",
      "switch_to_classic_widget" : "Mudar para o Widget Clássico",
      "switch_to_classic_widget_desc" : "O Dinâmico para o <b> WidgetClássico</b> irá Desativar automaticamente as definições à direita, uma vez que não podem existir:",
      "form_first_disabled" : "<b>O Formulário será movido para o segundo Passo</b> in Widget Ordenar.",
      "appointment_preference_disabled" : "A opção <b>Nova preferência de compromisso (marcar sempre com o utilizador atribuído do {contactLabel})</b> será desativada. Isto significa que os compromissos podem ser marcados com qualquer membro da equipa disponível, em vez de estarem restritos ao utilizador atribuído do {contactLabel}.",
      "multiple_location_disabled" : "<b>O endereço de várias Conferências</b> será Eliminado, e apenas a <b>primeira Localização adicionada</b> será retida.",
      "insert_custom_code_tooltip" : "Personalizar o estilo do Widget Via o seu próprio código CSS",
      "classic_tooltip_disabled" : "O widget clássico não é suportado para calendários de marcação de aulas",
      "show_staff_selection_disabled_tooltip" : "A seleção de pessoal é suportada apenas para o widget neo"
    },
    "roomsAndEquipments" : {
      "title" : "Selecionar Quarto e Equipamento",
      "description" : "Selecionar De a Lista de Quarto e Equipamento o que será reservado juntamente com este calendário",
      "rooms" : "Selecionar Quarto",
      "equipments" : "Selecionar Equipamento"
    }
  },
  "activity_log" : {
    "activity_log" : "Registo de atividades",
    "date" : "Data",
    "filter_by" : "Filtrar por",
    "calendar_update" : "Atualização de calendário",
    "start_time_update" : "Atualização da hora de início",
    "end_time_update" : "Atualização da hora de fim",
    "title_update" : "Atualização do Título",
    "notes_update" : "Atualização de Notas",
    "appointment_status_update" : "Atualização do estado da marcação",
    "meeting_location_update" : "Atualização da localização da reunião",
    "google_sync_update" : "Atualização de sincronização do Google",
    "outlook_sync_update" : "Atualização de sincronização do Outlook",
    "assigned_user_update" : "Atualização do Utilizador Atribuído",
    "appointment_status" : "Estado do compromisso",
    "assigned_user" : "Utilizador atribuído",
    "uploaded_to" : "Carregado para",
    "cancelled" : "Cancelado",
    "edited" : "editado",
    "other_edits" : "Outras edições",
    "view_details" : "Ver detalhes",
    "all" : "Todos"
  },
  "appointment_list" : {
    "group_all" : "TODOS",
    "group_primary" : "PRIMÁRIO",
    "group_user" : "UTILIZADORES",
    "group_team" : "GRUPOS",
    "group_calendar" : "CALENDÁRIOS",
    "all_appointments" : "Todos os Compromissos",
    "my_calendar" : "Meu calendário",
    "status_all" : "Todos",
    "status_confirmed" : "Confirmado",
    "status_new" : "Novo (ação necessária)",
    "status_show" : "Mostrado",
    "status_no_show" : "Não comparência",
    "status_cancelled" : "Cancelado",
    "status_invalid" : "Inválido",
    "filter_date_added_desc" : "Data adicionada (Desc)",
    "filter_start_added_desc" : "Data de início (Desc)",
    "filter_start_added_asc" : "Data de início ascendente a partir de hoje",
    "button_new_appointment" : "Novo compromisso",
    "name" : "Nome",
    "title" : "Título",
    "requested_time" : "Hora solicitada",
    "date_added" : "Data adicionada",
    "calendar" : "Calendário",
    "appointment_owner" : "Proprietário do compromisso",
    "notes" : "Notas",
    "status" : "Estado",
    "action_view_detail" : "Ver detalhes",
    "action_view_consent" : "Ver Consentimento",
    "action_view_notes" : "Ver notas",
    "action_edit" : "Editar",
    "action_delete" : "Eliminar",
    "action_reschedule" : "Reagendar",
    "page_previous" : "Anterior",
    "page_next" : "Seguinte",
    "appointment_notes" : "Notas do compromisso",
    "close" : "Fechar",
    "confirm_delete_header" : "Eliminar compromisso",
    "confirm_delete_message" : "Tem a certeza de que pretende eliminar este compromisso? Esta ação não pode ser anulada!",
    "confirm_delete_button" : "Eliminar",
    "confirm_update_header" : "Atualizar Estado da Consulta",
    "confirm_update_confirmed_message" : "Tem a certeza de que pretende marcar este compromisso como confirmado?",
    "confirm_update_invalid_message" : "Tem a certeza de que deseja marcar este compromisso como inválido?",
    "confirm_update_showed_message" : "Tem a certeza de que pretende marcar este compromisso como apresentado?",
    "confirm_update_noshow_message" : "Tem a certeza de que pretende marcar este compromisso como não comparência?",
    "confirm_update_cancelled_message" : "Tem a certeza de que deseja marcar este compromisso como cancelado?",
    "confirm_update_button" : "Atualizar",
    "empty_state_title" : "Nenhum compromisso encontrado",
    "empty_state_description" : "Nenhum compromisso encontrado",
    "disable_menu_warning" : "Atualmente, não tem Autorização para ver ou editar os Detalhes do compromisso, uma vez que o contacto associado não lhe está atribuído. Por favor, entre em contacto com o seu Administrador para obter mais assistência.",
    "no_contact_warning" : "Você não pode aceder às informações de contacto no momento. Isso pode ocorrer porque o contacto não lhe está atribuído. Entre em contacto com o seu administrador para obter assistência.",
    "consent_label" : "Consentimento",
    "ip_address" : "IP",
    "youre_viewing_in" : "Atualmente a visualizar em",
    "appointment_delete_msg" : "<b>Nota:</b> A marcação apagada aqui não será apagada do Calendly.",
    "rescheduled" : "Reagendado"
  },
  "add_guest" : {
    "guest_label" : "Convidado(s)",
    "search_placeholder" : "Pesquisar De Amigos",
    "add_new" : "Adicionar novo",
    "save" : "Arquivo",
    "close" : "Fechar",
    "name" : "Nome",
    "phone" : "Telefone",
    "email" : "E-mail",
    "guest_label_count" : "Contagem de Convidado",
    "guest_count_error" : "O Convidado Contagem deve ser entre 1 e 100"
  },
  "languages" : {
    "danish" : "Danish",
    "dutch" : "Dutch",
    "english" : "English",
    "finnish" : "Finnish",
    "french" : "French",
    "french_canada" : "French (Canada)",
    "german" : "German",
    "hungarian" : "Hungarian",
    "italian" : "Italian",
    "norwegian" : "Norwegian",
    "polish" : "Polish",
    "portuguese_brazil" : "Portuguese (Brazil)",
    "portuguese_portugal" : "Portuguese (Portugal)",
    "spanish" : "Spanish",
    "swedish" : "Swedish",
    "turkish" : "Turkish"
  },
  "service_menu_advanced" : {
    "new_service_menu_details_header" : "Detalhes do menu de serviços",
    "select_groups_header" : "Selecionar Serviços",
    "arrange_groups_header" : "Configure os seus Serviços",
    "new_service_menu" : "novo Menu de serviços",
    "service_menu_sub_title" : "Crie um menu de serviços Personalizado para os seus Clientes in apenas alguns cliques",
    "quick_tip" : "o utilizador pode Incluir Grupo ao menu de serviços",
    "service_menu_name" : "Nome do menu de serviços",
    "service_menu_description" : "Descrição",
    "service_menu_slug" : "URL do serviço",
    "select_groups_calendars" : "Selecionar Grupo e calendários",
    "select_groups_calendars_desc" : "Adicionar Serviços ao seu menu de serviços",
    "select_all" : "selecionar todos",
    "arrange_groups" : "Configurar Ordenar de Serviços",
    "arrange_groups_desc" : "determinar o Pipeline de serviços ativado o menu de serviços",
    "arrange_services_quicktip" : "Para calendários Reagendar dentro do Grupo, aceda a Grupo > Opções > Calendários Reagendar.",
    "enable_add_guest_desc" : "Ativar Clientes para Incluir hóspedes adicionais Ao fazer uma reserva.",
    "enable_multiple_service_desc" : "Ativar Clientes para marcar vários Serviços in Compromisso Individual .",
    "enable_staff_selection_desc" : "Ativar Clientes para selecionar a equipa preferida Membros Ao fazer uma reserva.",
    "enable_add_guest" : "Ativar Adicionar Convidados",
    "enable_multiple_service" : "Ativar seleção de vários serviços",
    "enable_staff_selection" : "Ativar seleção de pessoal",
    "additional_options" : "Opções adicionais",
    "code_block_tooltip" : "scripts de terceiros O interior do bloco HTML pode oferecer funcionalidades poderosas, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Por conseguinte, recomendamos que o utilizador para Rever o conteúdo deste Código Antes de A o guarde... no menu de serviço.",
    "custom_code_placeholder" : "Por favor, comentários Código personalizado aqui",
    "insert_custom_code" : "Inserir código personalizado",
    "no_service" : "Nenhum serviço encontrado",
    "no_service_desc" : " Nenhum serviço encontrado. Criar Serviços e Incluir os mesmos ao Grupo para Criar um menu de serviços.",
    "learn_more" : "Saiba mais",
    "no_service_selected" : "Nenhum serviço Selecionado",
    "create_service_calendars" : "Criar calendários de serviço",
    "alert_description" : " in menu do serviço Ordenar para Criar, o utilizador precisa de Criar calendários de serviço e Incluir-os no Grupo",
    "dont_show_again" : "Não mostrar isto novamente",
    "service_name_required" : "O nome do menu de serviços é necessário",
    "slug_already_taken" : "Este Slug já está a ser utilizado",
    "slug_required" : "Slug é Necessário",
    "please_enter_name" : "Introduzir um nome",
    "service_name_placeholder" : "Menu PRIMÁRIO",
    "service_slug_placeholder" : "menu principal",
    "form_label" : "Formulário",
    "consent_label" : "Caixa de verificação de Consentimento",
    "consent_input_placeholder" : "Adicionar Consentimento Corpo",
    "consent_tooltip" : "Ative esta opção para permitir a obtenção de consentimento de {contactsLabel} quando este fornece o número de telefone durante o processo de marcação de um compromisso.",
    "back_message" : "Voltar à Lista",
    "saving_changes" : "Só um minuto — A guardar... o último Dinâmico...",
    "payment_provider_warning" : "Atenção! Atualmente, os menus de serviço apenas suportam pagamentos através do Stripe e do Authorize.net. Como o seu fornecedor predefinido é diferente, a cobrança de pagamentos para os calendários selecionados com pagamentos ativos será ignorada.",
    "aria" : {
      "consent_form_toggle" : "Alternar formulário de consentimento",
      "enable_add_guest_toggle" : "Ativar alternância para adicionar convidado",
      "enable_multiple_services_toggle" : "Ativar alternância para vários serviços",
      "enable_staff_selection_toggle" : "Ativar alternância de seleção de pessoal"
    }
  },
  "widget_configuration" : {
    "customise_calendar_widget" : "Personalizar Widget de calendário",
    "works_with_neo_widget" : "Funciona apenas com Neo Widget",
    "customise_widget_desc" : "Personalizar Widget Aparência: PRIMÁRIO Cor, Fundo Cor e Botão Corpo.",
    "learn_more" : "Saiba mais",
    "primary_settings" : "Definições PRIMÁRIO",
    "primary_settings_desc" : "Configure as definições do Widget PRIMÁRIO Cor, Fundo Cor e Outros para personalizar o seu Widget de calendário",
    "primary_color" : "PRIMÁRIO Cor",
    "primary_color_desc" : "Definir o Cor para Botão, datas, Períodos de dados e atividades",
    "background_color" : "Cor de Fundo",
    "background_color_desc" : "Coleção o Fundo Cor que funciona como pano de fundo para o selecionador de data-hora e o Formulário.",
    "button_text" : "Botão Corpo",
    "button_text_desc" : "Personalizar o Corpo apresentado Ativado o Botão Quando marcar um Compromisso",
    "calendar_title" : "Título do calendário",
    "calendar_title_desc" : "O nome do seu calendário",
    "calendar_description" : "Descrição do calendário",
    "calendar_description_desc" : "A Descrição introduzida",
    "calendar_details" : "Detalhes do calendário",
    "calendar_details_desc" : "Inclui detalhes como Duração, Dados e Dados, Detalhes de Recorrente e fuso horário",
    "reset_to_default" : "Relatório para Predefinição",
    "preview_widget" : "Pré-visualizar Widget",
    "calendar_title_tooltip" : "Coleção Se, o Nome do calendário e o Nome do grupo (Se aplicável) devem estar visíveis Ativado o Widget de marcações.",
    "calendar_description_tooltip" : "Coleção Se a descrição do calendário deve estar visível Ativado o Widget de marcações.",
    "calendar_details_tooltip" : "Coleção Se os detalhes das reuniões da Chave, como Duração da Conferência, Dados e Dados Selecionados, e informações de recorrência (Se aplicável) devem estar visíveis Ativado o Widget de marcações.",
    "insert_custom_code_tooltip" : "Personalizar o estilo do Widget Via o seu próprio Código CSS .",
    "staff_selection_tooltip" : "Ativar Responsável pelas marcações para selecionar uma equipa Membros diretamente Do Widget de calendário durante a reserva de Compromisso. Funciona apenas com Neo Widget."
  },
  "eventNotification" : {
    "customFields" : "Campos Personalizado",
    "customValues" : "Valores personalizados",
    "guest" : "Convidado",
    "assignedUser" : "Utilizador atribuído",
    "additionalEmails" : "E-mails adicionais",
    "list" : {
      "booked" : {
        "title" : "Marcação reservada (Estado: Não confirmado)",
        "note" : "Esta notificação é enviada quando um novo compromisso é criado com o estado Não confirmado.",
        "subTitle" : "Notifica quando um compromisso é marcado com o estado Não confirmado"
      },
      "confirmation" : {
        "title" : "Consulta marcada (Status: Confirmado)",
        "note" : "Esta notificação é enviada quando uma marcação é criada ou atualizada para o estado Confirmado.",
        "subTitle" : "Notifica quando um compromisso é confirmado com sucesso"
      },
      "cancellation" : {
        "title" : "Cancelamento",
        "note" : "Esta notificação é enviada quando um compromisso é cancelado, marcado como no-show ou marcado como inválido.",
        "subTitle" : "Alerta quando um compromisso é cancelado"
      },
      "reschedule" : {
        "title" : "Reagendar",
        "note" : "Esta notificação é enviada quando um compromisso é reagendado. Ele só será acionado se o compromisso estiver in um estado não confirmado ou confirmado.",
        "subTitle" : "Notifica quando um compromisso é reagendado"
      },
      "reminder" : {
        "title" : "Lembrete",
        "note" : "Esta Notificação é enviada como um Lembrete Antes do Compromisso. Ele só será acionado se o compromisso estiver in um estado não confirmado ou confirmado.",
        "subTitle" : "Envia um lembrete antes do compromisso"
      },
      "followup" : {
        "title" : "Seguimento",
        "note" : "Esta notificação é enviada após a marcação como seguimento. Ele só será acionado se o compromisso estiver no estado Não confirmado, confirmado ou mostrado.",
        "subTitle" : "Envia uma mensagem de acompanhamento após a conclusão do compromisso"
      }
    },
    "saveToastMsg" : "Configurações guardadas!",
    "saveToastMsgDesc" : "As suas alterações foram guardadas com sucesso",
    "enableSuccess" : "Lembrete Ativado!",
    "disableSuccess" : "Lembrete Desativado!",
    "tooltip" : "Esta notificação foi desativada. Por favor, ative-a para fazer quaisquer alterações.",
    "enabled" : "Ativado",
    "disabled" : "Desativado",
    "statusLabel" : "Rótulos de estado",
    "email" : {
      "channelName" : "E-mail",
      "noneTemplate" : "Nenhum",
      "notificationLabel" : "Quem deve receber esta notificação?",
      "sendButtonLabel" : "Enviar e-mail de teste",
      "testEmailLabel" : "E-mail de teste",
      "testEmailPlaceholder" : "Introduzir o endereço de e-mail do destinatário para teste",
      "body" : "Corpo do e-mail",
      "bodyPlaceholder" : "Escrever a mensagem aqui",
      "subject" : "Assunto",
      "subjectPlaceholder" : "Introduzir o assunto do email",
      "templateLabel" : "Modelo de e-mail",
      "templatePlaceholder" : "Selecionar um modelo de e-mail ou começar do zero",
      "fromNamePlaceholder" : "Introduzir nome",
      "fromNameLabel" : "Por Nome",
      "fromAddressLabel" : "De Endereço",
      "alertEmailAddress" : "Introduza os IDs de e-mail (separado Via vírgulas)",
      "addMore" : "Adicionar mais",
      "afterAppointmentEnds" : "após o fim do compromisso",
      "beforeAppointmentStarts" : "antes do início do compromisso",
      "durationLabel" : "Quando é que pretende acionar a notificação?",
      "disableEmailNotification" : "Desativar notificações por e-mail",
      "enableEmailNotification" : "Ativar notificações por e-mail",
      "enableSuccess" : "Notificação por e-mail ativada!",
      "enableSuccessDesc" : "Vai começar agora a receber esta notificação",
      "disableSuccess" : "Notificação por e-mail desativada!",
      "disableSuccessDesc" : "Já não irá receber esta notificação",
      "reset_to_default" : "Relatório para Predefinição",
      "testEmailSuccessTitle" : "E-mail de teste enviado!",
      "testEmailSuccessDesc" : "O e-mail de teste foi enviado com sucesso para {email}",
      "testEmailErrorTitle" : "Falha ao enviar e-mail de teste",
      "testEmailErrorDesc" : "Ocorreu um erro no envio do e-mail de teste. Tente novamente."
    },
    "inApp" : {
      "channelName" : "Na aplicação",
      "title" : "Definições da notificação",
      "enableInAppNotification" : "Ativar notificação na aplicação",
      "disableInAppNotification" : "Desativar notificação na aplicação",
      "selectedUser" : {
        "label" : "Enviar para",
        "helperText" : "Esta notificação interna é enviada através da Web e das aplicações móveis",
        "placeholder" : "Selecionar utilizador(es)"
      },
      "enableSuccess" : "Notificações na aplicação ativadas!",
      "enableSuccessDesc" : "Vai começar agora a receber esta notificação",
      "disableSuccess" : "Notificações na aplicação desativadas!",
      "disableSuccessDesc" : "Já não irá receber esta notificação"
    },
    "sms" : {
      "channelName" : "SMS",
      "noneTemplate" : "Nenhum",
      "notificationLabel" : "Quem deve receber esta notificação?",
      "sendButtonLabel" : "Enviar SMS de teste",
      "testSMSLabel" : "SMS de teste (introduza o número de telefone com o indicativo do país)",
      "testSMSPlaceholder" : "+12345678901",
      "body" : "Mensagem SMS",
      "bodyPlaceholder" : "Escreva aqui a sua mensagem SMS",
      "durationLabel" : "Quando é que pretende acionar a notificação?",
      "disableSMSNotification" : "Desativar notificações por SMS",
      "enableSMSNotification" : "Ativar notificações por SMS",
      "enableSuccess" : "Notificação por SMS ativada!",
      "enableSuccessDesc" : "Vai começar agora a receber esta notificação",
      "disableSuccess" : "Notificação por SMS desativada!",
      "disableSuccessDesc" : "Já não irá receber esta notificação",
      "alertPhoneNumbers" : "Introduza os números de telefone (com indicativos de país, separados por vírgulas)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Adicionar mais",
      "afterAppointmentEnds" : "após o fim do compromisso",
      "beforeAppointmentStarts" : "antes do início do compromisso",
      "templateLabel" : "Modelo de SMS",
      "templatePlaceholder" : "Selecionar modelo de SMS...",
      "reset_to_default" : "Repor como predefinição",
      "testSmsSuccessTitle" : "SMS de teste enviado!",
      "testSmsSuccessDesc" : "O SMS de teste foi enviado com sucesso para {phone}",
      "testSmsErrorTitle" : "Falha ao enviar SMS de teste",
      "testSmsErrorDesc" : "Ocorreu um erro ao enviar o SMS de teste. Tente novamente."
    },
    "whatsapp" : {
      "channelName" : "WhatsApp",
      "notificationLabel" : "Quem deve receber esta notificação?",
      "sendButtonLabel" : "Enviar notificação do WhatsApp de teste",
      "testWhatsAppLabel" : "Notificação de WhatsApp de teste (insira o número de telefone com o indicativo do país)",
      "testWhatsAppPlaceholder" : "+12345678901",
      "durationLabel" : "Quando é que pretende acionar a notificação?",
      "alertPhoneNumbers" : "Introduza os números de telefone (com indicativos de país, separados por vírgulas)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Adicionar mais",
      "afterAppointmentEnds" : "após o fim do compromisso",
      "beforeAppointmentStarts" : "antes do início do compromisso",
      "templateLabel" : "Modelo do WhatsApp",
      "templatePlaceholder" : "Selecionar modelo do WhatsApp...",
      "noPreview" : "Nenhum modelo selecionado",
      "templateRequired" : "Modelo Necessário",
      "testWhatsAppSuccessTitle" : "Notificação do WhatsApp de teste enviada!",
      "testWhatsAppSuccessDesc" : "A notificação do WhatsApp de teste foi enviada com sucesso para {phone}",
      "testWhatsAppErrorTitle" : "Falha a carregar a notificação do WhatsApp de teste",
      "testWhatsAppErrorDesc" : "Ocorreu um erro ao enviar a notificação do WhatsApp de teste. Tente novamente.",
      "setupTitle" : "Entre em contacto com o seu cliente na respetiva aplicação de mensagens favorita",
      "setupDescription" : "Mantenha-se mais próximo dos seus clientes ao fornecer suporte instantâneo, enviar atualizações oportunas e criar interações envolventes.",
      "connectWhatsApp" : "Ligar WhatsApp",
      "checkingStatus" : "A verificar o estado da conta de WhatsApp…",
      "checkingTemplateStatus" : "A verificar o estado do modelo do WhatsApp...",
      "statusCheckError" : "Falha ao verificar o estado da conta de WhatsApp",
      "templateStatusCheckError" : "Falha ao verificar o estado do modelo de WhatsApp",
      "setupTemplateTitle" : "Conclua a configuração do seu modelo do WhatsApp",
      "setupTemplateDescription" : "Precisa de configurar modelos do WhatsApp antes de poder enviar notificações. Clique abaixo para concluir o processo de configuração.",
      "loadTemplatesError" : "Falha ao carregar modelos de WhatsApp",
      "templatesRefreshed" : "Modelos atualizados com sucesso",
      "templatesRefreshError" : "Falha ao atualizar os modelos",
      "templatesResolveError" : "Erro ao resolver modelos predefinidos do WhatsApp",
      "locationNotFound" : "ID de localização não encontrado",
      "settingsRedirectError" : "Não é possível redirecionar para as definições do WhatsApp",
      "updateNotificationError" : "Falha ao atualizar a notificação de WhatsApp",
      "notificationsEnabled" : "Notificações do WhatsApp ativadas!",
      "notificationsDisabled" : "Notificações do WhatsApp desativadas!",
      "updateError" : "Erro ao atualizar as notificações",
      "createNewTemplate" : "Criar novo modelo de WhatsApp",
      "phoneValidation" : {
        "countryCodeRequired" : "O número de telefone deve começar com um indicativo de país (por exemplo, +1, +91, +44)",
        "digitsOnly" : "O número de telefone deve conter apenas dígitos após o indicativo do país",
        "tooShort" : "O número de telefone é demasiado curto",
        "tooLong" : "O número de telefone é demasiado longo",
        "invalid" : "Número de telefone inválido"
      },
      "errors" : {
        "templateNotFound" : "ID do modelo não encontrado nas opções carregadas, a limpar",
        "templateNoLongerValid" : "O modelo guardado já não é válido, a limpar",
        "invalidTemplateSelection" : "Tentativa de selecionar um modelo de WhatsApp inválido",
        "fetchingTemplates" : "Erro ao obter modelos WhatsApp",
        "mountingCreator" : "Erro ao montar o criador de modelos WhatsApp",
        "fetchingAfterCreation" : "Erro ao obter modelos WhatsApp após a criação",
        "updateStatus" : "Erro ao atualizar o estado do WhatsApp"
      },
      "receiverLabels" : {
        "assignedUser" : "Utilizador atribuído",
        "phoneNumbers" : "Números de telefone adicionais"
      }
    }
  },
  "smsTemplate" : {
    "create_new_template" : "Criar um novo modelo de SMS",
    "create_new_template_desc" : "Crie um modelo de SMS reutilizável para as suas notificações",
    "template_name" : "Nome do modelo",
    "template_name_placeholder" : "Introduza o nome do modelo",
    "message" : "Mensagem",
    "message_placeholder" : "Escreva aqui a sua mensagem SMS",
    "create_template" : "Criar modelo",
    "name_required" : "O nome do modelo é obrigatório",
    "text_required" : "O texto da mensagem é obrigatório",
    "fetch_new_templates" : "Atualizar modelos"
  },
  "whatsappTemplate" : {
    "create_new_template" : "Criar Novo Modelo de WhatsApp",
    "create_new_template_desc" : "Crie um modelo reutilizável do WhatsApp para as suas notificações",
    "template_name" : "Nome do modelo",
    "template_name_placeholder" : "Introduza o nome do modelo",
    "message" : "Mensagem",
    "message_placeholder" : "Escreva aqui a sua mensagem do WhatsApp",
    "create_template" : "Criar modelo",
    "name_required" : "O nome do modelo é obrigatório",
    "text_required" : "O texto da mensagem é obrigatório",
    "fetch_new_templates" : "Atualizar modelos"
  },
  "archivedServices" : {
    "servicesBanner" : "Está aqui uma nova Versão de Serviços atualizada — mais poderosa, flexível e intuitiva. Os seus calendários de serviço já foram migredos. Explore-os agora in separador Serviços.",
    "archivedServiceCalendars" : "Calendários de serviço (v1)",
    "check_new_services" : "Marcação de verificação novo Serviços"
  },
  "tour" : {
    "hidden_test_label" : "Testar",
    "calendar" : {
      "edit_calendar" : "Editar calendário",
      "share_calendar" : "Partilhar calendário",
      "troubleshoot_calendar" : "Resolução de problemas de calendário",
      "more_options" : "Mais Opções",
      "edit_calendar_desc" : "Gerir todas as definições de calendário — Fixo Disponibilidade, Configurar Lembrete, Modificar limites de Compromisso e muito mais.",
      "share_calendar_desc" : "Copiar e Partilhe a sua Ligação de agendamento, pelo que o Responsável pelas marcações pode agendar facilmente com o Utilizador.",
      "troubleshoot_calendar_desc" : "Descubra por que uma posição não está em Apresentação e veja os potenciais Motivos na Ver de resolução de problemas.",
      "more_options_desc" : "Acesso definições e atividades adicionais para gerar o seu calendário.",
      "read_permissions" : {
        "share_description" : "Conceda acesso a outros partilhando a ligação do calendário ou ajustando as permissões.",
        "troubleshoot_description" : "Identifique e resolva problemas como erros de sincronização ou eventos em falta para garantir uma funcionalidade sem problemas."
      },
      "next" : "Seguinte",
      "start_over" : "Começar de novo",
      "all_set" : "todos Coleção!",
      "previous" : "Anterior"
    }
  },
  "emailTemplate" : {
    "select_editing_experience" : "Selecionar a sua experiência de edição",
    "select_editing_experience_desc" : "selecionar para construir Via do nosso Editor visual de desenho de arrastar e largar Ou poderosa Editor de código",
    "design_editor" : "Editor de desenho",
    "design_editor_desc" : "Edição visual, Arrastar e largar.",
    "code_editor" : "Editor de código",
    "code_editor_desc" : "Caraterísticas-RICH HTML Editing.",
    "text_editor" : "Editor de código simples",
    "text_editor_desc" : "Edição de corpo Simples, Limpar e sem Frescuras.",
    "email_text_block" : "O e-mail também pode ser Criado Via Bloco Corpo. ",
    "select" : "Selecionar",
    "new_template" : "novo Modelo",
    "email_block" : "O e-mail também pode ser Criado Via Bloco Corpo.",
    "fetch_new_templates" : "Obter novos modelos"
  },
  "quick_tips" : {
    "meeting_details" : {
      "include_contact_and_user_names" : "Para incluir o nome do contacto e o nome do utilizador do compromisso no título da reunião, utilize o seguinte formato: &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url" : "Para garantir um acesso ininterrupto, adicione um URL de reunião personalizado como opção de reserva, caso haja problemas com as integrações do Zoom ou do Gmeet.",
      "enable_gmeet_primary" : "Para ativar a funcionalidade do Gmeet, certifique-se de que o Calendário Google do membro da equipa está definido como o calendário primário nas definições"
    },
    "availability" : {
      "twenty_four_hours" : "Para tornar o calendário disponível 24 horas, defina o intervalo de tempo de 12 AM a 12 AM.",
      "update_timezone_preferences" : "Os fusos horários podem ser alterados em qualquer altura em Perfil da Empresa >> Preferências de Fuso horário.",
      "service_calendar_slot_interval" : "Defina a disponibilidade do seu calendário de serviços, com um intervalo padrão de 15 minutos entre compromissos."
    },
    "forms" : {
      "create_custom_forms" : "Crie facilmente formulários personalizados na secção de Marketing em \"Formulários\" e integre-os perfeitamente em calendários para uma recolha de dados organizada.",
      "apply_sticky_contacts" : "Quando adicionar um formulário personalizado, as definições de contactos fixas ligadas ao formulário serão aplicadas automaticamente.",
      "use_custom_values" : "Tem a opção de incluir valores personalizados e campos de contactos tanto na mensagem do formulário como no URL do formulário."
    },
    "notifications" : {
      "use_workflows" : "Para notificações avançadas, use Fluxos de trabalho ou Acionadores de compromisso marcado."
    },
    "customizations" : {
      "update_widget_language" : "Para alterar as definições de língua do Widget, siga estes passos: Configuração >> Calendários >> Preferências >> Preferências da conta."
    },
    "equipments" : {
      "room_definition" : "Uma \"sala\" pode representar qualquer localização onde são realizados os serviços. Podem ser salas físicas e/ou estações dedicadas. Por ex.: estação de pedicure.",
      "equipment_definition" : "Pense em \"equipamento\" como qualquer ferramenta ou dispositivo que as empresas usam para executar os compromissos. Isso pode incluir máquinas, dispositivos ou até cadeiras."
    }
  },
  "aria_labels" : {
    "sticky_contacts" : "Contactos fixos",
    "consent_form" : "Formulário de Consentimento",
    "enable_guests" : "Ativar convidados",
    "auto_confirm" : "Confirmação automática",
    "should_accept_payment" : "Deve aceitar pagamento",
    "collect_deposit" : "Recolher depósito",
    "enable_charge_guests" : "Ativar cobrança a convidados",
    "enable_coupon" : "Ativar cupão",
    "payment_live" : "Pagamento em direto",
    "add_availability_hour" : "Adicionar hora de disponibilidade",
    "remove_availability_hour" : "Remover hora de disponibilidade",
    "copy_availability_hour" : "Copiar hora de disponibilidade",
    "close_modal" : "Fechar Modal",
    "add_custom_slot" : "Adicionar posição personalizada",
    "remove_custom_slot" : "Remover posição personalizada",
    "edit_custom_slot" : "Editar posição personalizada",
    "update_frequency" : "Atualizar frequência",
    "show_calendar_title" : "Mostrar título do calendário",
    "show_calendar_description" : "Mostrar descrição do calendário",
    "show_calendar_details" : "Mostrar informações do calendário",
    "allow_reschedule" : "Permitir reagendamento",
    "allow_cancellation" : "Permitir cancelamento",
    "category_actions" : "Ações da categoria"
  },
  "placeholders" : {
    "pixel_id" : "ID do pixel",
    "select_one" : "Selecionar um",
    "meeting_location" : "Localização da reunião",
    "schedule_meeting" : "Agendar reunião",
    "notes" : "Notas",
    "select_users" : "Selecionar utilizadores"
  },
  "alt_text" : {
    "payment_provider" : "Fornecedor de pagamentos",
    "no_calendars" : "Sem calendários",
    "date_specific_hours" : "horas-especificas-por-data",
    "custom_widget_image" : "Imagem de widget personalizada",
    "service_calendar" : "Calendário de serviços",
    "event_calendar" : "Calendário de Eventos",
    "round_robin_booking" : "Reserva com distribuição sequencial",
    "class_booking" : "Reserva de aulas",
    "collective_booking" : "Reserva coletiva"
  },
  "tooltips" : {
    "text_color" : "Cor do texto",
    "background_color" : "Cor de fundo",
    "strikethrough" : "Rasurado",
    "superscript" : "Sobrescrito",
    "subscript" : "Subscrito",
    "inline_code_block" : "Bloco de código em linha",
    "code_block" : "Bloco de código",
    "block_quote" : "Bloco de estimativa",
    "more" : "Mais",
    "upload" : "Carregar"
  },
  "labels" : {
    "reset_style" : "Repor estilo",
    "reset_document_style" : "Repor o estilo do documento",
    "source_code" : "Código-fonte",
    "success" : "Sucesso",
    "edit" : "Editar",
    "submit" : "Enviar",
    "cancel" : "Cancelar",
    "payment" : "Pagamento",
    "here_is_the_link" : "Aqui está a ligação:",
    "here_is_the_embed_code" : "Aqui está o código de incorporação:",
    "service_calendar" : "Calendário de serviços",
    "collective_booking" : "Reserva coletiva",
    "class_booking" : "Reserva de aulas",
    "round_robin_booking" : "Reserva com distribuição sequencial",
    "event_calendar" : "Calendário de Eventos",
    "personal_booking" : "Reserva pessoal",
    "service_booking" : "Marcação de serviço"
  },
  "validation_messages" : {
    "calendar_group_name_required" : "O nome do grupo de calendários é obrigatório",
    "calendar_group_description_required" : "A descrição do grupo de calendários é obrigatória",
    "slug_required" : "O slug é obrigatório",
    "slug_not_valid" : "Este slug não é válido",
    "slug_already_taken" : "Este slug já está a ser utilizado",
    "error_validating_slug" : "Erro ao validar o slug",
    "please_enter_name" : "Introduza um nome",
    "room_name_required" : "O nome da sala é obrigatório",
    "equipment_name_required" : "O nome do equipamento é obrigatório",
    "subject_required" : "O assunto é obrigatório",
    "this_is_required" : "Isto é obrigatório",
    "calendar_group_slug_required" : "O slug do grupo de calendários é obrigatório",
    "capacity_mandatory" : "Capacidade é obrigatória",
    "capacity_cannot_be_zero" : "A capacidade não pode ser zero",
    "capacity_should_be_a_number" : "A capacidade deve ser um número",
    "capacity_cannot_be_negative" : "A capacidade não pode ser negativa",
    "capacity_should_be_a_whole_number" : "A capacidade deve ser um número inteiro",
    "quantity_mandatory" : "A quantidade é obrigatória",
    "quantity_cannot_be_zero" : "A quantidade não pode ser zero",
    "quantity_should_be_a_number" : "A quantidade deve ser um número",
    "quantity_cannot_be_negative" : "A quantidade não pode ser negativa",
    "quantity_should_be_a_whole_number" : "A quantidade deve ser um número inteiro",
    "quantity_cannot_be_less_than_out_of_service_equipments" : "A quantidade não pode ser inferior aos equipamentos fora de serviço",
    "out_of_service_value_should_be_a_number" : "O valor fora de serviço deve ser um número",
    "out_of_service_cannot_be_negative" : "Fora de serviço não pode ser negativo",
    "out_of_service_equipments_qty" : "Os equipamentos fora de serviço não podem exceder a quantidade real de equipamentos",
    "out_of_service_whole_number" : "O fora de serviço deve ser um número inteiro",
    "slot_duration_required" : "A duração do período é obrigatória",
    "slot_duration_integer" : "A duração do período tem de ser um número inteiro",
    "meeting_duration_validation" : "A duração da reunião deve estar entre 1 mínima e 12 horas",
    "seats_class_required" : "Assentos por aula é obrigatório",
    "seats_class_integer" : "Os assentos por aula têm de ser um número inteiro",
    "seats_class_validation" : "Isto não pode ser superior a 9999 nem inferior a 0",
    "meeting_location_required" : "Local da reunião é obrigatório"
  },
  "custom_values" : {
    "assigned_user" : "Utilizador atribuído",
    "full_name" : "Nome completo",
    "first_name" : "Nome próprio",
    "last_name" : "Apelido",
    "email" : "E-mail",
    "phone" : "Telefone",
    "twilio_phone" : "Telefone Twilio",
    "account" : "Conta",
    "name" : "Nome",
    "full_address" : "Endereço completo",
    "city" : "Cidade",
    "state" : "Distrito",
    "country" : "País",
    "postal_code" : "Código postal",
    "contact" : "Contacto",
    "address1" : "Endereço 1",
    "timezone" : "Fuso horário",
    "user" : "Utilizador",
    "appointment" : "Compromisso",
    "start_date_time" : "Data e hora de início",
    "start_date" : "Data de início",
    "start_time" : "Hora de início",
    "end_date_time" : "Data e hora de fim",
    "end_date" : "Data de fim",
    "end_time" : "Hora de fim",
    "meeting_location" : "Localização da reunião"
  },
  "meeting_location_types" : {
    "zoom" : "Zoom",
    "google_meet" : "Google Meet",
    "phone" : "Telefone",
    "full_address" : "Endereço completo",
    "microsoft_teams" : "Microsoft Teams",
    "custom" : "Personalizar"
  },
  "duration_units" : {
    "minutes" : "Minutos",
    "hours" : "Horas"
  },
  "widget_styles" : {
    "classic" : "Clássico",
    "neo" : "Neo"
  },
  "feature_labels" : {
    "service_menu" : "Menu de serviços",
    "rooms" : "Salas",
    "equipments" : "Equipamentos"
  },
  "lsa" : {
    "categories" : {
      "accountant" : "Contabilidade",
      "acupuncturist" : "Acupuntura",
      "air_duct_cleaner" : "Limpeza de condutas de ar",
      "alcohol_treatment" : "Serviços de tratamento de alcoolismo",
      "animal_shelter" : "Serviços de Resgate de Animais",
      "appliance_repair" : "Reparação de Eletrodomésticos",
      "architect" : "Arquitetura",
      "assisted_living" : "Serviços de assistência domiciliária",
      "babysitter" : "Babysitting",
      "bankruptcy_lawyer" : "Legislação relativa a falências",
      "beauty_school" : "Escola de estética",
      "business_lawyer" : "Direito comercial",
      "car_repair" : "Serviços automáticos",
      "carpenter" : "Carpintaria",
      "carpet_cleaning" : "Limpeza de carpetes",
      "child_care" : "Serviços de cuidados infantis",
      "chiropractor" : "Serviços de Quiropraxia",
      "cleaning_service" : "Limpeza doméstica",
      "contract_lawyer" : "Direito dos contratos",
      "countertop_pro" : "Serviços de balcão",
      "criminal_lawyer" : "Direito Penal",
      "dance_instructor" : "Instrução de dança",
      "disability_lawyer" : "Legislação relativa a pessoas com deficiência",
      "driving_instructor" : "Instruções de condução",
      "dui_lawyer" : "Legislação relativa à condução sob o efeito do álcool",
      "electrician" : "Elétrico",
      "energy_efficiency_pro" : "Serviços de Eficiência Energética",
      "estate_lawyer" : "Direito imobiliário",
      "event_planner" : "Planeamento de Eventos",
      "family_lawyer" : "Direito da Família",
      "fencing_pro" : "Esgrima",
      "financial_planner" : "Planeamento financeiro",
      "first_aid_trainer" : "Formação de primeiros socorros",
      "flooring_pro" : "Pavimento",
      "foundation_pro" : "Bases",
      "funeral_home" : "Serviços funerários",
      "garage_door_pro" : "Porta de Garagem",
      "general_contractor" : "Melhorias em casa",
      "handyman" : "Faz-tudo",
      "home_inspector" : "Inspeção da casa",
      "home_security" : "Serviços de segurança residencial",
      "home_theater" : "Serviços de cinema em casa",
      "hvac" : "AVAC",
      "immigration_lawyer" : "Lei de Imigração",
      "interior_designer" : "Design de interiores",
      "ip_lawyer" : "Legislação relativa à propriedade intelectual",
      "junk_removal" : "Remoção de entulho",
      "labor_lawyer" : "Direito do trabalho",
      "landscaper" : "Paisagismo",
      "language_instructor" : "Instrução de língua",
      "lawn_care" : "Manutenção de relvados",
      "litigation_lawyer" : "Direito contencioso",
      "locksmith" : "Serralheiro",
      "malpractice_lawyer" : "Legislação relativa a más práticas",
      "massage_center" : "Serviços de Massagem",
      "massage_school" : "Escola de Massagem",
      "mover" : "Mudanças",
      "nursing_home" : "Serviço de lar de idosos",
      "painter" : "Pintura",
      "personal_injury_lawyer" : "Legislação relativa a danos pessoais",
      "personal_trainer" : "Formação pessoal",
      "pest_control" : "Controlo de pragas",
      "pet_adoption" : "Serviços de adoção de animais de estimação",
      "pet_boarding" : "Alojamento de animais de estimação",
      "pet_grooming" : "Tosquia de animais de estimação",
      "pet_trainer" : "Treino de animais de estimação",
      "photographer" : "Fotografia",
      "plumber" : "Canalização",
      "pool_cleaner" : "Limpeza de Piscinas",
      "pool_contractor" : "Contratação de pool",
      "preschool" : "Pré-escolar",
      "psychologist" : "Serviços de Psicologia",
      "real_estate_agent" : "Imobiliário",
      "real_estate_lawyer" : "Direito Imobiliário",
      "rehab" : "Serviços de Reabilitação",
      "roofer" : "Telhados",
      "sewage_pro" : "Serviços de sistemas de esgotos",
      "siding_pro" : "Revestimento",
      "smart_home" : "Serviços domésticos inteligentes",
      "snow_removal" : "Serviços de remoção de neve",
      "spa" : "Serviços de Spa",
      "tax_lawyer" : "Legislação fiscal",
      "tax_specialist" : "Serviços de impostos",
      "therapist" : "Terapia",
      "towing_pro" : "Assistência em viagem",
      "traffic_lawyer" : "Legislação de trânsito",
      "tree_service" : "Serviços de arborização",
      "tutor" : "Tutoria",
      "upholstery_cleaner" : "Limpeza de Estofos",
      "veterinarian" : "Serviços Veterinários",
      "videographer" : "Serviços de Vídeo",
      "water_damage" : "Serviços de danos por água",
      "weight_loss_service" : "Serviços de perda de peso",
      "window_cleaner" : "Limpeza de janelas",
      "window_repair" : "Serviços de limpeza de vidros",
      "windshield_repair_pro" : "Auto Glass",
      "yoga_instructor" : "Ioga"
    },
    "job_types" : {
      "accountant_other" : "Outro",
      "bankruptcy_tax_litigation" : "Contencioso de impostos de falência",
      "bookkeeping" : "Contabilidade",
      "business_consulting" : "Consultoria empresarial",
      "debt_collection_relief" : "Alívio na cobrança de dívidas",
      "irs_representation_resolution" : "Apresentação e resolução do IRS",
      "payroll" : "Folha de pagamento",
      "tax_planning_business" : "Empresa de planeamento de impostos",
      "tax_planning_individual" : "Indivíduo de planeamento de impostos",
      "tax_return_business" : "Empresa de declaração de impostos",
      "tax_return_individual" : "Indivíduo de declaração de impostos",
      "trusts_estates_accounting" : "Contabilidade de imobiliário e obrigações",
      "acupressure" : "Acupressão",
      "acupuncture" : "Acupuntura",
      "acupuncturist_other" : "Outro",
      "cupping" : "Ventosas",
      "gua_sha" : "Gua Sha",
      "heat_therapy" : "Terapia de calor",
      "herbal_therapy" : "Terapia com ervas",
      "infrared_therapy" : "Terapia de Infravermelhos",
      "moxibustion" : "Moxabustão",
      "qigong" : "Qigong",
      "shiatsu" : "Shiatsu",
      "tui_na" : "Tui Na",
      "air_duct_cleaning" : "Limpeza de condutas de ar",
      "air_duct_filter_replacement" : "Substituição de filtros",
      "air_duct_other" : "Outro",
      "dryer_vent_cleaning" : "Limpeza de conduta de secador",
      "furnace_cleaning" : "Limpeza de forno",
      "indoor_air_quality_testing" : "Teste de Qualidade do Ar Interior",
      "alcohol_treatment_other" : "Outro",
      "animal_shelter_cat_adoption" : "Adoção de Gatos",
      "animal_shelter_dog_adoption" : "Adoção de Cães",
      "animal_shelter_other" : "Outro",
      "animal_shelter_other_animal_adoption" : "Adoção de Outros Animais",
      "animal_shelter_other_veterinary_services" : "Outros Serviços Veterinários",
      "animal_shelter_spay_neuter" : "Esterilizar ou castrar",
      "animal_shelter_vaccinations" : "Vacinas",
      "lost_stray_found_animals" : "Animais perdidos, abandonados ou encontrados",
      "pet_license" : "Licença para animal de estimação",
      "pet_surrender" : "Entrega de Animais de Estimação",
      "appliance_other" : "Outro",
      "repair_dishwasher" : "Reparar máquina de lavar louça",
      "repair_dryer" : "Reparar secador",
      "repair_freezer" : "Reparar congelador",
      "repair_microwave" : "Reparar Micro-ondas",
      "repair_oven" : "Reparar forno",
      "repair_refrigerator" : "Reparação de frigorífico",
      "repair_refrigerator_freezer" : "Reparação de frigorífico/congelador",
      "repair_stove_cooktop" : "Reparação de fogão/placa",
      "repair_stove_cooktop_oven" : "Reparação de fogão/placa/forno",
      "repair_washer" : "Reparar máquina de lavar",
      "repair_washer_dryer" : "Reparar máquina de lavar/secar",
      "3d_architectural_rendering" : "Renderização Arquitetónica 3D",
      "adaptive_reuse_historical_renovation" : "Reutilização adaptativa e renovação histórica",
      "architect_other" : "Outro",
      "architectural_designing" : "Design arquitetónico",
      "architectural_engineering" : "Engenharia arquitetónica",
      "building_code_analysis_permit_coordination" : "Análise de código e permissões",
      "consulting" : "Consultoria",
      "home_building_improvement" : "Construção e melhoria de casa",
      "interior_design_architect" : "Design de interiores",
      "planning_zoning_approval_assistance" : "Aprovação de planificação e criação de zonas",
      "project_managing_architect" : "Gestão de Projetos",
      "site_master_planning" : "Planeamento geral do local",
      "assisted_living_housekeeping_and_laundry" : "Serviços de limpeza e lavandaria",
      "assisted_living_meal_services" : "Serviços de Refeições",
      "assisted_living_memory_care" : "Cuidados de Memória",
      "assisted_living_other" : "Outro",
      "assisted_living_rehabilitation_services" : "Serviços de Reabilitação",
      "assisted_living_transportation" : "Transporte",
      "assisted_living_wellness_programs" : "Programas de bem-estar",
      "daily_living_assistance" : "Assistência para a vida diária",
      "medication_management" : "Gestão de Medicamentos",
      "short_term_stays" : "Estadias de curta duração",
      "social_and_recreational_activities" : "Atividades Recreativas",
      "babysitter_other" : "Outro",
      "event_babysitting" : "Babysitting em eventos",
      "homework_assistance" : "Assistência com os trabalhos de casa",
      "housekeeping_laundry" : "Serviços de limpeza e lavandaria",
      "meal_preparation" : "Preparação de Refeições",
      "nanny_services" : "Serviços de ama",
      "overnight_babysitting" : "Babysitting noturno",
      "pick_up_and_drop_off" : "Recolha e entrega",
      "shopping_errand" : "Compras e recados",
      "special_needs_care" : "Cuidados para Necessidades Especiais",
      "virtual_babysitting" : "Babysitting Virtual",
      "agriculture_bankruptcy" : "Falência agrícola",
      "bankruptcy_lawyer_other" : "Outro",
      "bankruptcy_litigation" : "Litígios de falência",
      "chapter_11_bankruptcy" : "Falência ao abrigo do Capítulo 11",
      "chapter_13_bankruptcy" : "Falência ao abrigo do Capítulo 13",
      "chapter_7_bankruptcy" : "Falência ao abrigo do Capítulo 7",
      "corporate_bankruptcy" : "Falência empresarial",
      "creditor_harassment" : "Assédio por credores",
      "debt_settlement" : "Pagamento de dívida",
      "foreclosure_bankruptcy_lawyer" : "Execução hipotecária",
      "personal_bankruptcy" : "Falência Pessoal",
      "repossession" : "Retoma",
      "wage_garnishment" : "Penhora de Salário",
      "beauty_school_barbering" : "Barbearia",
      "beauty_school_business_management" : "Gestão de empresa",
      "beauty_school_cosmetology" : "Cosmetologia",
      "beauty_school_esthetics" : "Estética",
      "beauty_school_hair_cutting" : "Corte de cabelo",
      "beauty_school_hair_design" : "Cabeleireiro",
      "beauty_school_makeup" : "Maquilhagem",
      "beauty_school_massage_therapy" : "Terapia de Massagem",
      "beauty_school_nail_technology" : "Tecnologia de Unhas",
      "beauty_school_other" : "Outro",
      "beauty_school_retail_training" : "Formação sobre retalho",
      "banking_finance_law" : "Banca e Finanças",
      "business_lawyer_other" : "Outro",
      "business_licenses_permits" : "Licenças e alvarás comerciais",
      "business_litigation" : "Litígios empresariais",
      "business_taxes" : "Impostos sobre as empresas",
      "business_transactions_business_lawyer" : "Transações de empresa",
      "commercial_bankruptcy" : "Insolvência comercial",
      "commercial_contracts_business_lawyer" : "Contratos Comerciais",
      "employment_law_business_lawyer" : "Lei do Trabalho",
      "incorporation_restructuring" : "Incorporação e reestruturação",
      "insurance_law" : "Direito dos seguros",
      "intellectual_property_law" : "Direito da Propriedade Intelectual",
      "mergers_acquisitions_business_lawyer" : "Fusões e aquisições",
      "partnership_agreements_business_lawyer" : "Contratos de parceria",
      "patents_copyrights_trademarks" : "Patentes, direitos de autor e marcas registadas",
      "securities_law" : "Lei de Valores Mobiliários",
      "shareholder_disputes" : "Litígios de acionistas",
      "air_and_cabin_filter" : "Filtros de ar e cabine",
      "battery" : "Bateria",
      "body_and_trim" : "Carroçaria e acabamentos",
      "brakes" : "Travões",
      "car_air_conditioning" : "Ar Condicionado",
      "car_electrical" : "Elétrico",
      "car_repair_other" : "Outro",
      "check_engine_light_diagnostic" : "Verificar o diagnóstico de luz do motor",
      "exhaust" : "Escape",
      "oil_change" : "Mudança de óleo",
      "steering_suspension" : "Direção / Suspensão",
      "tires" : "Pneus",
      "transmission" : "Transmissão",
      "cabinetry" : "Marcenaria",
      "carpenter_other" : "Outro",
      "decking" : "Decking",
      "drywalling" : "Instalação de placa de gesso",
      "fencing" : "Vedações",
      "general_installations" : "Instalações Gerais",
      "general_repairs_maintenance" : "Reparações gerais e manutenção",
      "remodeling" : "Remodelação",
      "shelving_storage" : "Estantes e arrumação",
      "carpet_cleaning_other" : "Outro",
      "clean_area_rugs" : "Limpar tapetes",
      "clean_carpet" : "Limpar carpetes",
      "clean_drapes_and_curtains" : "Limpar cortinas e estores",
      "clean_upholstery" : "Limpeza de estofos",
      "remove_pet_stains_and_odors" : "Limpar manchas e odores de animais de estimação",
      "after_school_care" : "ATL (Atividades de tempos livres)",
      "all_hours_daycare" : "Creche aberta 24 horas",
      "bilingual_daycare" : "Creche bilingue",
      "child_care_other" : "Outro",
      "drop_in_daycare" : "Serviço de creche pontual",
      "full_time_daycare" : "Creche a tempo inteiro",
      "in_home_daycare" : "Creche ao domicílio",
      "infant_programs" : "Programas para Bebés",
      "part_time_daycare" : "Creche a tempo parcial",
      "pre_kindergarten_programs" : "Programas pré-escolares",
      "preschool_programs" : "Programas pré-escolares",
      "school_age_programs" : "Programas para idade escolar",
      "special_needs_daycare" : "Creche para necessidades especiais",
      "summer_daycare" : "Creche de verão",
      "toddler_programs" : "Programas para Crianças Pequenas",
      "weekend_daycare" : "Creche de fim de semana",
      "chiropractor_acupuncture" : "Acupuntura",
      "chiropractor_chiropractic" : "Quiropraxia",
      "chiropractor_massage_therapy" : "Massoterapia",
      "chiropractor_other" : "Outro",
      "diagnosis" : "Diagnóstico",
      "eastern_medicine" : "Medicina tradicional oriental",
      "exercise_counseling" : "Aconselhamento sobre exercício",
      "pain_management" : "Gestão da Dor",
      "physical_therapy" : "Fisioterapia",
      "spinal_adjustments" : "Ajustes da coluna vertebral",
      "sports_medicine" : "Medicina Desportiva",
      "cleaner_other" : "Outro",
      "deep_clean" : "Limpeza Profunda",
      "moving_clean" : "Limpeza de mudanças",
      "office_clean" : "Limpeza de Escritório",
      "standard_clean" : "Limpeza padrão",
      "assignment_of_contract" : "Atribuição de contrato",
      "business_transactions_contract_lawyer" : "Transações de empresa",
      "commercial_contracts_contract_lawyer" : "Contratos comerciais",
      "contract_dispute" : "Disputa de contrato",
      "contract_lawyer_other" : "Outro",
      "contract_negotiation" : "Negociação de contrato",
      "contract_review" : "Revisão de contrato",
      "employment_contracts_contract_lawyer" : "Contratos de trabalho",
      "franchise_agreements" : "Contratos de franchise",
      "mergers_acquisitions_contract_lawyer" : "Fusões e aquisições",
      "non_disclosure_agreements_contract_lawyer" : "Acordos de confidencialidade",
      "partnership_agreements_contract_lawyer" : "Contratos de parceria",
      "power_of_attorney_contract_lawyer" : "Procuração",
      "security_agreements" : "Acordos de segurança",
      "warranties" : "Garantias",
      "bathroom_countertops" : "Bancadas de Casa de Banho",
      "bathroom_wall_panels" : "Painéis de Parede para Casa de Banho",
      "countertop_design" : "Design de bancadas",
      "countertop_installation" : "Instalação de Bancadas",
      "countertop_pro_other" : "Outro",
      "fireplace_facade" : "Fachada de lareira",
      "granite_countertops" : "Bancadas de granito",
      "kitchen_countertops" : "Bancadas de Cozinha",
      "kitchen_wall_panels" : "Painéis de parede de cozinha",
      "laminate_countertops" : "Bancadas laminadas",
      "marble_countertops" : "Bancadas de Mármore",
      "quartz_countertops" : "Tampas de quartzo",
      "remodeling_countertop_pro" : "Remodelação",
      "repair_maintenance_countertop_pro" : "Reparação e manutenção",
      "stone_slab_countertops" : "Bancadas de pedra",
      "tile_countertops" : "Bancadas de azulejos",
      "corporate_representation" : "Representação corporativa",
      "criminal_immigration_defense" : "Defesa criminal de imigração",
      "criminal_lawyer_other" : "Outro",
      "domestic_violence" : "Violência doméstica",
      "drug_possession" : "Posse de drogas",
      "duis_reckless_driving" : "Condução sob o efeito do álcool e condução imprudente",
      "expungement" : "Expurgação",
      "federal_crimes" : "Crimes federais",
      "felonies" : "Crimes graves",
      "petty_crimes_misdemeanors" : "Pequenos crimes e contraordenações",
      "restraining_orders" : "Providências cautelares",
      "sex_offenses" : "Crimes de género",
      "three_strikes_law" : "Legislação aplicável após três infrações",
      "dance_instructor_african" : "Africano",
      "dance_instructor_ballet" : "Ballet",
      "dance_instructor_ballroom" : "Salão de Baile",
      "dance_instructor_belly" : "Barriga",
      "dance_instructor_bollywood" : "Bollywood",
      "dance_instructor_contemporary" : "Contemporâneo",
      "dance_instructor_folk_traditional" : "Folk e tradicional",
      "dance_instructor_hip_hop" : "Hip Hop",
      "dance_instructor_jazz" : "Jazz",
      "dance_instructor_kids_classes" : "Aulas para crianças",
      "dance_instructor_latin" : "Latim",
      "dance_instructor_modern" : "Moderno",
      "dance_instructor_other" : "Outro",
      "dance_instructor_tap" : "Toque",
      "dance_instructor_wedding" : "Casamento",
      "disability_hearings" : "Audiências de incapacidade",
      "disability_lawyer_other" : "Outro",
      "long_term_disability" : "Incapacidade a longo prazo",
      "short_term_disability" : "Incapacidade a curto prazo",
      "social_security_disability_insurance" : "Seguro de incapacidade da segurança social",
      "ssa_claim_reconsideration" : "Reconsideração de reivindicação SSA",
      "ssa_disability_appeals" : "Recursos SSA para incapacidade",
      "ssa_disability_applications" : "Aplicações SSA para incapacidade",
      "ssa_disability_benefits" : "Benefícios SSA para incapacidade",
      "ssa_family_benefits" : "Benefícios familiares SSA",
      "ssa_impairment_listings" : "Listagens SSA para incapacidade",
      "supplemental_security_income" : "Rendimento de segurança suplementar",
      "veterans_disability_benefits" : "Benefícios por incapacidade para veteranos",
      "workers_compensation_disability_lawyer" : "Compensação dos Trabalhadores",
      "behind_the_wheel_lessons" : "Aulas de condução prática",
      "commercial_license_training" : "Formação de carta de condução comercial",
      "defensive_driving_lessons" : "Aulas de Condução Defensiva",
      "drivers_education_classes" : "Cursos de educação para condutores",
      "driving_instructor_other" : "Outro",
      "manual_transmission_lessons" : "Aulas de mudanças manuais",
      "motorcycle_lessons" : "Aulas de moto",
      "traffic_school" : "Escola de condução",
      "dui_dwi_dui_lawyer" : "Condução sob o efeito do álcool",
      "dui_injuries_dui_lawyer" : "Condução sob o efeito do álcool com lesão",
      "dui_lawyer_other" : "Outro",
      "dui_with_accident" : "Condução sob o efeito do álcool com acidente",
      "felony_dui" : "Condução sob o efeito do álcool com crime",
      "invalid_tests" : "Testes inválidos",
      "multiple_offenses" : "Várias infrações",
      "reckless_driving_dui_lawyer" : "Condução Imprudente",
      "underage_dui" : "Condução sob o efeito do álcool por menor de idade",
      "electric_car_charger" : "Instalar carregador de carro elétrico",
      "electrician_other" : "Outro",
      "electrician_remodeling" : "Remodelação",
      "install_fan" : "Instalar ventoinha",
      "install_ground_wire" : "Instalar fio de terra",
      "install_light_fixtures" : "Instalar candeeiros",
      "install_outdoor_lighting" : "Instalar iluminação exterior",
      "install_outlets_switches" : "Instalar tomadas ou interruptores",
      "install_security_system" : "Instalar sistema de segurança",
      "relocate_outlets_switches" : "Mover as saídas ou os interruptores",
      "repair_fan" : "Reparar ventoinha",
      "repair_light_fixtures" : "Reparar candeeiros",
      "repair_outlets_switches" : "Reparar tomadas ou interruptores",
      "repair_panel" : "Reparar painel",
      "replace_upgrade_panel" : "Substituir ou fazer upgrade do painel",
      "restore_power" : "Restaurar Energia",
      "energy_efficiency_pro_other" : "Outro",
      "charitable_giving" : "Doações de caridade",
      "contests_litigation" : "Concursos/Contencioso",
      "deeds" : "Ações",
      "estate_lawyer_other" : "Outro",
      "estate_planning_lawyer" : "Planeamento imobiliário",
      "guardianship_estate_lawyer" : "Tutela",
      "medical_power_of_attorney" : "Procuração médica",
      "power_of_attorney_estate_lawyer" : "Procuração",
      "probate_estate_lawyer" : "Advogado de heranças e sucessões",
      "trusts" : "Obrigações",
      "wills" : "Testamentos",
      "anniversary_planner" : "Aniversário",
      "baby_shower_planner" : "Chá de bebé",
      "bar_and_bat_mitzvah_planner" : "Bar e Bat Mitzvah",
      "birthday_party" : "Festa de aniversário",
      "children_party" : "Festa de crianças",
      "corporate_and_conference_planner" : "Corporativo e conferência",
      "event_planner_other" : "Outro",
      "quinceanera_planner" : "Quinceanera",
      "religious_event" : "Evento Religioso",
      "retirement_party" : "Festa de reforma",
      "school_event" : "Evento Escolar",
      "theme_party" : "Festa temática",
      "wedding_and_engagement_planner" : "Casamento e Noivado",
      "adoption" : "Adoção",
      "child_support" : "Suporte para dependentes",
      "contested_divorce" : "Divórcio contestado",
      "debt_division" : "Divisão de Dívida",
      "family_lawyer_other" : "Outro",
      "guardianship_family_lawyer" : "Tutela",
      "mediation_family_lawyer" : "Mediação",
      "modifications_of_orders" : "Modificação de encomendas",
      "parent_timesharing" : "Partilha de tempo entre pais",
      "paternity" : "Paternidade",
      "prenuptial_postnuptial_agreements" : "Acordos pré-nupciais e acordos matrimoniais",
      "probate_family_lawyer" : "Sucessões",
      "property_divisions" : "Divisão de propriedade",
      "protective_orders_domestic_violence_issues" : "Ordens de Restrição",
      "spousal_support_alimony" : "Apoio ao cônjuge e pensão de alimentos",
      "uncontested_divorce" : "Divórcio não contestado",
      "custom_construction" : "Construção personalizada",
      "fence_design" : "Design de vedações",
      "fencing_other" : "Outro",
      "installation_fencing_pro" : "Instalação de vedações",
      "repairs_maintenance_fencing_pro" : "Reparações e Manutenção",
      "education_savings" : "Poupança para a educação",
      "estate_financial_planning" : "Planeamento imobiliário",
      "financial_planning" : "Planeamento financeiro",
      "financial_planning_other" : "Outro",
      "home_purchase" : "Compra de casa",
      "insurance" : "Seguro",
      "investment_advising" : "Aconselhamento de investimento",
      "retirement_savings" : "Reforma",
      "tax_planning" : "Planeamento de impostos",
      "advanced_cardiac_life_support" : "Suporte cardíaco avançado de vida",
      "aed_defibrillator" : "DEA - Desfibrilhador",
      "basic_life_support" : "Suporte de vida básico",
      "cpr" : "RCP",
      "first_aid" : "Primeiros Socorros",
      "first_aid_trainer_other" : "Outro",
      "pediatric_advanced_life_support" : "Suporte de vida avançado pediátrico",
      "pediatric_cpr_first_aid" : "RCP pediátrica e primeiros socorros",
      "pet_cpr_first_aid" : "RCP e primeiros socorros para animais",
      "wilderness_first_aid" : "Primeiros socorros na natureza",
      "baseboards" : "Rodapés",
      "carpet" : "Carpete",
      "flooring_other" : "Outro",
      "hardwood" : "Madeira maciça",
      "installation_flooring_pro" : "Instalação de pavimentos",
      "marble" : "Mármore",
      "polishing" : "Polimento de pavimentos",
      "refinishing" : "Acabamento de pavimentos",
      "repair_maintenance_flooring_pro" : "Reparação e manutenção de pavimentos",
      "stair_flooring" : "Pavimento de escadas",
      "tile" : "Azulejo",
      "wood_floor_sanding" : "Lixamento de pavimentos de madeira",
      "basement_waterproofing" : "Impermeabilização de caves",
      "crawl_spaces" : "Fundação de espaço rastejante",
      "foundation_drainage" : "Drenagem de fundação",
      "foundation_installation" : "Instalação de fundação",
      "foundation_pro_other" : "Outro",
      "foundation_raising" : "Elevação da fundação",
      "repairs_maintenance_foundation_pro" : "Reparações e manutenção",
      "slab_foundation" : "Base da fundação",
      "steel_pier_pilings" : "Estacas de aço para cais",
      "water_moisture_control" : "Controlo de água e humidade",
      "burials" : "Enterros",
      "caskets" : "Caixões",
      "cremation" : "Cremação",
      "funeral_home_flowers" : "Flores",
      "funeral_home_other" : "Outro",
      "funeral_home_transportation_transfers" : "Transporte e transferências",
      "funeral_home_veteran_services" : "Serviços para Veteranos",
      "funerals" : "Funerais",
      "gravestones" : "Lápides",
      "grief_services" : "Serviços de luto",
      "memorials" : "Memoriais",
      "urns" : "Urnas",
      "garage_door_other" : "Outro",
      "general_maintenance" : "Manutenção Geral",
      "install_garage_door" : "Instalar porta da garagem",
      "install_opener" : "Instalar fecho",
      "repair_cables" : "Reparar Cabos",
      "repair_garage_door" : "Reparar porta de garagem",
      "repair_gate" : "Reparar Portão",
      "repair_rollers_tracks" : "Reparação de rodas e trilhos",
      "replace_door_panels" : "Substituir painéis de porta",
      "replace_opener" : "Substituir fecho",
      "replace_springs" : "Substituir Molas",
      "accessory_buildings" : "Edifícios acessórios",
      "bathroom_remodel" : "Remodelação de Casa de Banho",
      "decks_patio" : "Decks e Pátios",
      "exterior_finishing" : "Acabamento exterior",
      "foundations_concrete" : "Fundações e betão",
      "general_contractor_commercial_projects" : "Projetos Comerciais",
      "general_contractor_other" : "Outro",
      "home_addition" : "Adição de casa",
      "home_building" : "Construção de casa",
      "home_remodel_renovation" : "Remodelação e renovação de casa",
      "interior_finishing" : "Acabamento Interior",
      "kitchen_remodel" : "Remodelação de Cozinha",
      "roofing" : "Telhados",
      "assemble_furniture" : "Montar Móveis",
      "clean_gutters" : "Limpar caleiras",
      "handyman_other" : "Outro",
      "install_drywall" : "Instalar placa de gesso",
      "install_flooring" : "Instalar pavimento",
      "install_tile" : "Instalar azulejos",
      "install_water_fixtures" : "Instalar torneiras e acessórios de água",
      "mount_tv" : "Montar TV",
      "paint_indoors" : "Pintar interiores",
      "paint_outdoors" : "Pintar exteriores",
      "repair_drywall" : "Reparar placa de gesso",
      "repair_flooring" : "Reparar pavimentos",
      "repair_water_fixtures" : "Reparar torneiras e acessórios de água",
      "replace_tile" : "Substituir azulejos",
      "buyer_seller_inspection" : "Inspeção de comprador e vendedor",
      "commercial_properties" : "Propriedades Comerciais",
      "fire_safety" : "Segurança Contra Incêndios",
      "fireplace_chimney" : "Lareira e chaminé",
      "full_home_inspection" : "Inspeção completa da casa",
      "home_inspector_electrical" : "Elétrico",
      "home_inspector_foundation" : "Fundação",
      "home_inspector_hvac" : "AVAC",
      "home_inspector_mold" : "Bolor",
      "home_inspector_new_construction" : "Nova Construção",
      "home_inspector_other" : "Outro",
      "home_inspector_plumbing" : "Canalização",
      "home_inspector_roof" : "Telhado",
      "home_inspector_structural" : "Estrutural",
      "home_warranty" : "Garantia da casa",
      "water_testing" : "Testes de água",
      "well_or_septic_system" : "Poço ou sistema séptico",
      "wood_insects" : "Madeira e Insetos",
      "access_control" : "Controlo de acesso",
      "alarm_systems" : "Sistemas de Alarme",
      "commercial_security_systems" : "Sistemas de Segurança Comercial",
      "fire_smoke_detection" : "Deteção de incêndio e fumo",
      "home_security_doors" : "Portas",
      "home_security_locks" : "Fechos",
      "home_security_other" : "Outro",
      "home_security_windows" : "Janelas",
      "monitoring_services" : "Serviços de Monitorização",
      "residential_security_systems" : "Sistemas de segurança residencial",
      "smart_home_integration" : "Integração de casa inteligente",
      "video_surveillance" : "Videovigilância",
      "audio_video_installation" : "Instalação de Áudio e Vídeo",
      "commercial_projects" : "Projetos comerciais",
      "home_theater_design" : "Design de cinema em casa",
      "home_theater_lighting" : "Iluminação",
      "home_theater_other" : "Outro",
      "home_theater_smart_home_integration" : "Integração de casa inteligente",
      "install_tv" : "Instalar TV",
      "network_it_services" : "Serviços de rede e TI",
      "outdoor_installations" : "Instalações ao ar livre",
      "soundproofing" : "Insonorização",
      "whole_house_audio_video" : "Vídeo e áudio da casa completa",
      "ac_maintenance" : "Manutenção de AC",
      "clean_ducts_vents" : "Limpar condutas e ventoinhas",
      "ductless_heating_and_ac_services" : "Aquecimento sem condutas e serviços de ar condicionado",
      "heating_maintenance" : "Manutenção de Aquecimento",
      "hvac_maintenance" : "Manutenção HVAC",
      "hvac_other" : "Outro",
      "install_ac" : "Instalar AC",
      "install_ducts_vents" : "Instalar condutas e ventoinhas",
      "install_heating_system" : "Instalar sistema de aquecimento",
      "install_thermostat" : "Instalar termóstato",
      "repair_ac" : "Reparar AC",
      "repair_ducts_vents" : "Reparar condutas e ventoinhas",
      "repair_heating_system" : "Reparar sistema de aquecimento",
      "repair_hvac" : "Reparar AVAC",
      "repair_thermostat" : "Reparar termóstato",
      "asylum" : "Asilo",
      "citizenship" : "Cidadania",
      "deportation" : "Deportação",
      "family_based_immigration" : "Imigração com base na família",
      "green_card" : "Green Card",
      "immigration_lawyer_other" : "Outro",
      "investment_visa" : "Visto de Investimento",
      "outbound_work_permits" : "Autorizações de trabalho de saída",
      "student_visa" : "Visto de Estudante",
      "visitor_visa" : "Visto de visitante",
      "work_visa" : "Visto de Trabalho",
      "appliance_selection" : "Seleção de eletrodomésticos",
      "cabinetry_molding_hardware_design" : "Design de armários e ferragens",
      "decorating" : "Decoração",
      "door_design" : "Design de porta",
      "exterior_building_design" : "Design de exteriores de edifícios",
      "flooring_selection" : "Seleção de Pavimentos",
      "interior_designer_other" : "Outro",
      "landscaping_design" : "Design de paisagismo",
      "lighting_design" : "Design de iluminação",
      "multifamily_housing_design" : "Design de habitação multifamiliar",
      "room_planning" : "Planeamento de salas",
      "stone_brick_stucco_design" : "Design de pedra, tijolo e estuque",
      "window_design" : "Design de janelas",
      "advertisements" : "Anúncios",
      "copyright" : "Direitos de autor",
      "export_control" : "Controlo de exportações",
      "franchises" : "Franchises",
      "international_ip" : "IP Internacional",
      "ip_lawyer_other" : "Outro",
      "ip_strategy" : "Estratégia de IP",
      "ip_transactions" : "Transações de IP",
      "licensing" : "Licenciamento",
      "litigation_ip_lawyer" : "Litígio",
      "non_disclosure_agreements_ip_lawyer" : "Acordos de confidencialidade",
      "patents" : "Patentes",
      "technology_transfer" : "Transferência de tecnologia",
      "trade_secrets" : "Segredos Comerciais",
      "trademarks" : "Marcas comerciais",
      "appliance_removal" : "Remoção de eletrodomésticos",
      "construction_waste_removal" : "Remoção de Resíduos de Construção",
      "donation_pickup" : "Recolha de doações",
      "electronic_waste_removal" : "Remoção de lixo eletrónico",
      "furniture_removal" : "Remoção de mobiliário",
      "general_junk_removal" : "Remoção de entulho geral",
      "hazardous_waste_removal" : "Remoção de Resíduos Perigosos",
      "house_garage_cleanout" : "Limpeza de Casa/Garagem",
      "junk_removal_other" : "Outro",
      "yard_waste_removal" : "Remoção de Resíduos de Jardim",
      "employment_contracts_labor_lawyer" : "Contratos de trabalho",
      "employment_law_labor_lawyer" : "Direito do Trabalho",
      "exempt_employee_status" : "Estado de trabalhador isento",
      "labor_law" : "Direito do Trabalho",
      "labor_lawyer_other" : "Outro",
      "labor_negotiations" : "Negociações laborais",
      "privacy_rights" : "Direitos de privacidade",
      "sexual_harassment" : "Assédio Sexual",
      "unpaid_overtime" : "Horas extra não pagas",
      "whistle_blowing" : "Denúncia",
      "workers_compensation_labor_lawyer" : "Compensação dos trabalhadores",
      "wrongful_termination" : "Demissão injusta",
      "artificial_turf_installation" : "Instalação de Relva Artificial",
      "concrete_masonry" : "Alvenaria de betão",
      "driveway_landscaping" : "Paisagismo de entrada de automóveis",
      "garden_decorations" : "Decorações de jardim",
      "grading_resloping" : "Nivelamento e reclassificação",
      "hardscapes" : "Hardscapes",
      "landscape_design" : "Design paisagístico",
      "landscape_installations" : "Instalações paisagísticas",
      "landscaper_other" : "Outro",
      "outdoor_steps" : "Degraus exteriores",
      "outdoor_water_feature" : "Fontes de água exteriores",
      "paving_driveway_walkway" : "Pavimentação de entradas ou passagens",
      "retaining_walls" : "Muros de contenção",
      "sidewalk_walkway_landscaping" : "Paisagismo de caminhos",
      "sod_seeding" : "Relva e semeadura",
      "stone_masonry" : "Alvenaria de Pedra",
      "arabic" : "Árabe",
      "english" : "English",
      "french" : "French",
      "german" : "German",
      "hebrew" : "Hebraico",
      "italian" : "Italian",
      "japanese" : "Japonês",
      "korean" : "Coreano",
      "language_instructor_other" : "Outro",
      "mandarin" : "Mandarim",
      "portuguese" : "Português",
      "russian" : "Russo",
      "sign_language" : "Língua Gestual",
      "spanish" : "Spanish",
      "irrigation_system_repair_maintenance" : "Reparação / Manutenção do Sistema de Irrigação",
      "lawn_care_other" : "Outro",
      "lawn_mowing_maintenance" : "Corte de relva/Manutenção",
      "lawn_pest_control" : "Controlo de pragas de relva",
      "mulching" : "Mulching",
      "seeding" : "Sementeira",
      "sod_installation" : "Instalação de relvado",
      "weed_control" : "Controlo de ervas daninhas",
      "yard_cleanup" : "Limpeza de jardim",
      "appeals" : "Recursos",
      "case_assessment_litigation_lawyer" : "Avaliação de Caso",
      "civil_litigation" : "Contencioso civil",
      "commercial_litigation" : "Litígios Comerciais",
      "contracts_and_agreements" : "Contratos e acordos",
      "criminal_litigation" : "Contencioso penal",
      "litigation_lawyer_other" : "Outro",
      "mediation_litigation_lawyer" : "Mediação",
      "settlements" : "Liquidações",
      "building_lockout" : "Bloqueio de construção",
      "copy_building_key" : "Copiar chaves de construção",
      "copy_vehicle_key" : "Copiar chave do veículo",
      "install_hardware" : "Instalar hardware",
      "locksmith_other" : "Outro",
      "new_key_fob" : "Novo Porta-chaves",
      "rekey_lock" : "Reconfigurar bloqueio",
      "repair_hardware" : "Reparar hardware",
      "vehicle_lockout" : "Bloqueio de veículos",
      "consent_issues" : "Questões de consentimento",
      "diagnosis_errors" : "Erros de diagnóstico",
      "malpractice_lawyer_other" : "Outro",
      "medical_negligence" : "Negligência Médica",
      "treatment_errors" : "Erros de Tratamento",
      "massage_center_other" : "Outro",
      "massage_school_advanced_neuromuscular_therapy" : "Terapia Neuromuscular Avançada",
      "massage_school_business_and_ethics" : "Empresa e Ética",
      "massage_school_clinical_therapies" : "Terapias clínicas",
      "massage_school_continuing_education" : "Formação contínua",
      "massage_school_deep_tissue_massage" : "Massagem de tecidos profundos",
      "massage_school_energetics" : "Energia",
      "massage_school_hydrotherapy" : "Hidroterapia",
      "massage_school_lymphatic_massage" : "Massagem linfática",
      "massage_school_online_massage_therapy" : "Terapia de Massagem Online",
      "massage_school_other" : "Outro",
      "massage_school_prenatal_massage" : "Massagem pré-natal",
      "massage_school_sports_massage" : "Massagem Desportiva",
      "massage_school_student_massage_clinic" : "Clínica de massagem para estudantes",
      "massage_school_swedish_massage" : "Massagem sueca",
      "massage_theory" : "Teoria da Massagem",
      "massage_therapy_training" : "Cursos de Massoterapia",
      "in_state_move" : "Mudança dentro do Estado",
      "local_move" : "Mudança local",
      "mover_other" : "Outro",
      "moving_junk_removal" : "Remoção de entulho",
      "moving_storage" : "Armazenamento",
      "out_of_state_move" : "Mudança para fora do Estado",
      "oversized_item_move" : "Mudança de artigo sobredimensionado",
      "packing_unpacking" : "Embalar/Desembalar",
      "senior_move" : "Mudança de sénior",
      "vehicle_transport" : "Transporte de Veículos",
      "cardiac_care" : "Cuidados cardíacos",
      "general_medical_care" : "Cuidados Médicos Gerais",
      "hospice" : "Cuidados paliativos",
      "iv_therapy" : "Terapia IV",
      "nursing_home_meal_services" : "Serviços de refeições",
      "nursing_home_memory_care" : "Cuidados com a memória",
      "nursing_home_other" : "Outro",
      "nursing_home_pain_management" : "Gestão da dor",
      "nursing_home_rehabilitation_services" : "Serviços de reabilitação",
      "nursing_home_wellness_programs" : "Programas de bem-estar",
      "outpatient_rehabilitation" : "Reabilitação em ambulatório",
      "post_hospital_care" : "Cuidados pós-hospitalares",
      "respiratory_and_pulmonary_care" : "Cuidados Respiratórios e Pulmonares",
      "senior_activity_programs" : "Programas de atividades para seniores",
      "short_term_rehabilitation" : "Reabilitação a curto prazo",
      "wound_care" : "Cuidados de Feridas",
      "exterior_painting" : "Pintura Exterior",
      "interior_painting" : "Pintura de Interiores",
      "paint_cabinets" : "Pintar Armários",
      "paint_doors" : "Pintar Portas",
      "painter_other" : "Outro",
      "repair_water_damage" : "Reparar danos provocados pela água",
      "staining" : "Coloração",
      "assault_battery" : "Agressão e Lesão Corporal",
      "auto_accidents" : "Acidentes automóveis",
      "bicycle_accidents" : "Acidentes de Bicicleta",
      "catastrophic_injuries" : "Lesões catastróficas",
      "dog_bites" : "Mordeduras de cães",
      "dui_injuries_personal_injury_lawyer" : "Lesões por condução sob o efeito do álcool",
      "medical_malpractice" : "Negligência Médica",
      "motorcycle_accidents" : "Acidentes de moto",
      "pain_suffering" : "Dor e sofrimento",
      "pedestrian_accidents" : "Acidentes de Peões",
      "personal_injury_lawyer_other" : "Outro",
      "product_liability" : "Responsabilidade do Produto",
      "slip_fall" : "Escorregamento e queda",
      "uninsured_motorist_claims" : "Reclamações de seguro de motorista",
      "workers_compensation_personal_injury_lawyer" : "Compensação dos trabalhadores",
      "wrongful_death" : "Morte por negligência",
      "aerobics" : "Aeróbica",
      "athletic_performance" : "Desempenho atlético",
      "circuit_training" : "Treino em circuito",
      "endurance" : "Resistência",
      "fitness_assessment" : "Avaliação de aptidão física",
      "hiit" : "HIIT",
      "nutritional_counseling" : "Aconselhamento Nutricional",
      "personal_trainer_other" : "Outro",
      "strength_conditioning" : "Força e Condicionamento",
      "weight_loss" : "Perda de Peso",
      "yoga" : "Ioga",
      "ants" : "Formigas",
      "bed_bugs" : "Percevejos",
      "bees" : "Abelhas",
      "cockroaches" : "Baratas",
      "fleas_or_mites" : "Pulgas ou Ácaros",
      "hornets_or_wasps" : "Vespas ou abelhas",
      "mosquitoes" : "Mosquitos",
      "pest_control_other" : "Outro",
      "pest_inspection" : "Inspeção",
      "rodents" : "Roedores",
      "spiders" : "Aranhas",
      "termites" : "Térmitas",
      "wildlife" : "Vida selvagem",
      "pet_adoption_birds" : "Pássaros",
      "pet_adoption_cats" : "Gatos",
      "pet_adoption_dogs" : "Cães",
      "pet_adoption_farm_animals" : "Animais de Quinta",
      "pet_adoption_fish" : "Peixe",
      "pet_adoption_other" : "Outro",
      "pet_adoption_reptiles" : "Répteis",
      "pet_adoption_small_mammals" : "Pequenos mamíferos",
      "pet_adoption_special_needs_animals" : "Animais com Necessidades Especiais",
      "cat_boarding" : "Alojamento para gatos",
      "cat_grooming" : "Tosquia de gatos",
      "cat_sitting_in_home" : "Pet sitting de gatos (ao domicílio)",
      "dog_boarding" : "Alojamento para cães",
      "dog_boarding_with_training" : "Alojamento para cães com treino",
      "dog_daycare" : "Creche para Cães",
      "dog_grooming" : "Tosquia de cães",
      "dog_sitting_in_home" : "Pet sitting de cães (ao domicílio)",
      "dog_training" : "Treino de cães",
      "dog_walking" : "Passeio de Cães",
      "other_pet_boarding" : "Outros serviços de alojamento para animais de estimação",
      "other_pet_daycare" : "Outras creches para animais de estimação",
      "other_pet_grooming" : "Outros serviços de tosquia de animais de estimação",
      "other_pet_sitting_in_home" : "Outros serviços de pet sitting (ao domicílio)",
      "pet_boarding_other" : "Outro",
      "cat_bathing" : "Banho de Gato",
      "cat_ear_cleaning" : "Limpeza de orelhas de gato",
      "cat_grooming_and_styling" : "Tosquia e estilo de gatos",
      "cat_nail_trimming" : "Corte de unhas de gato",
      "dog_anal_gland_expression" : "Expressão da glândula anal de cão",
      "dog_bathing_and_blow_dry" : "Banho de cão e secagem",
      "dog_ear_cleaning" : "Limpeza de orelhas de Cão",
      "dog_flea_and_tick_treatment" : "Tratamento de pulgas e carraças para cães",
      "dog_full_service_grooming" : "Serviço completo de tosquia para cães",
      "dog_grooming_and_styling" : "Tosquia e estilo de cães",
      "dog_nail_trimming" : "Corte de unhas de cães",
      "dog_teeth_brushing" : "Limpeza de dentes de cão",
      "pet_grooming_other" : "Outro",
      "aggressive_dog_training" : "Treino de cães agressivos",
      "behavior_modification" : "Modificação de Comportamento",
      "obedience_training" : "Treino de obediência",
      "offleash_training" : "Treino sem trela",
      "pet_trainer_other" : "Outro",
      "puppy_training" : "Treino de cachorros",
      "service_animal_training" : "Cursos de serviços para animais",
      "sport_trick_training" : "Treino de desporto ou truques",
      "training_other_animals" : "Treino para outros animais",
      "corporate_photo" : "Corporativo",
      "events_and_parties_photo" : "Eventos e festas",
      "family_and_group_photo" : "Família e Grupo",
      "headshots_and_portraits" : "Fotografias de rosto e retratos",
      "individual_photo" : "Individual",
      "maternity_and_newborn_photo" : "Maternidade e recém-nascido",
      "photographer_other" : "Outro",
      "product_photo" : "Produto",
      "real_estate_photo" : "Imobiliário",
      "school_portraits" : "Retratos Escolares",
      "wedding_and_engagement_photo" : "Casamento e Noivado",
      "find_leak" : "Descobrir e reparar fugas",
      "install_faucet" : "Instalar Torneira",
      "install_garbage_disposal" : "Instalar triturador de lixo",
      "install_shower" : "Instalar chuveiro",
      "install_toilet" : "Instalar sanita",
      "install_water_heater" : "Instalar Aquecedor de Água",
      "plumbing_other" : "Outro",
      "repair_faucet" : "Reparar Torneira",
      "repair_garbage_disposal" : "Reparar o triturador de lixo",
      "repair_outdoor_systems" : "Reparar sistemas exteriores",
      "repair_pipe" : "Reparar Tubo",
      "repair_sewer" : "Reparar esgotos",
      "repair_shower" : "Reparar chuveiro",
      "repair_toilet" : "Reparar Sanita",
      "repair_water_heater" : "Reparar Esquentador",
      "unclog_drain" : "Desentupir drenagem",
      "commercial_pool_cleaning_maintenance" : "Limpeza e Manutenção de Piscinas Comerciais",
      "equipment_maintenance_repair" : "Reparação e manutenção de equipamento",
      "one_time_pool_cleaning" : "Limpeza única de piscina",
      "ongoing_pool_cleaning" : "Limpeza contínua da piscina",
      "pool_cleaner_other" : "Outro",
      "pool_cleaner_water_features" : "Propriedades de água",
      "seasonal_opening_closing" : "Abertura e fecho sazonais",
      "spa_hot_tub_cleaning" : "Limpeza de spa e banheira de hidromassagem",
      "spa_hot_tub_repairs" : "Reparações de spas e banheiras de hidromassagem",
      "tile_pool_wall_cleaning" : "Limpeza de Azulejos e Paredes de Piscina",
      "water_testing_balancing" : "Teste e equilíbrio de água",
      "jetted_lap_pools" : "Piscinas de corrente para natação",
      "pool_construction" : "Construção de Piscinas",
      "pool_contractor_commercial_projects" : "Projetos comerciais",
      "pool_contractor_custom_designs" : "Designs personalizados",
      "pool_contractor_other" : "Outro",
      "pool_contractor_renovation" : "Renovação",
      "pool_contractor_repair_cracks" : "Reparar fissuras",
      "pool_contractor_repair_tile" : "Reparar Azulejo",
      "pool_contractor_resurfacing" : "Recapeamento",
      "pool_contractor_water_features" : "Propriedades de água",
      "pool_hot_tub_equipment" : "Equipamento para piscinas e banheiras de hidromassagem",
      "spa_hot_tub_installation" : "Instalação de Spa e Banheira de Hidromassagem",
      "bilingual_programs" : "Programas bilíngues",
      "early_preschool" : "Pré-escola inicial",
      "full_day_preschool" : "Pré-escola dia completo",
      "half_day_preschool" : "Pré-escola meio dia",
      "kindergarten_classes" : "Aulas em jardim de infância",
      "montessori_programs" : "Programas Montessori",
      "play_based_preschool" : "Pré-escola baseada em jogo",
      "preschool_infant_programs" : "Programas para Bebés",
      "preschool_other" : "Outro",
      "reggio_emilia_preschool" : "Pré-escolar Reggio Emilia",
      "special_needs_programs" : "Programas para necessidades especiais",
      "summer_camp" : "Acampamento de Verão",
      "waldorf_preschool" : "Pré-escola Waldorf",
      "psychologist_other" : "Outro",
      "buyer_agent" : "Agente do Comprador",
      "first_time_home_buyer" : "Comprador de primeira casa",
      "foreclosed_properties" : "Propriedades em execução hipotecária",
      "luxury_properties" : "Propriedades de luxo",
      "new_construction" : "Nova Construção",
      "property_management" : "Gestão de propriedades",
      "real_estate_agent_other" : "Outro",
      "relocation" : "Relocalização",
      "rentals" : "Arrendamentos",
      "sellers_agent" : "Agente do vendedor",
      "commercial_real_estate" : "Imobiliário Comercial",
      "easements" : "Servidões",
      "encroachment" : "Invasão",
      "foreclosure_real_esate_lawyer" : "Execução hipotecária",
      "landlord_tenant_law" : "Legislação relativa a senhorios e inquilinos",
      "litigation_real_estate_lawyer" : "Litígio",
      "mortgage_lending_law" : "Lei hipotecária e de empréstimos",
      "neighbor_hoa_disputes" : "Disputas entre vizinhos e HOA",
      "property_damage" : "Danos materiais",
      "purchase_agreements" : "Acordos de compra",
      "real_estate_contracts_transactions" : "Vendas imobiliárias",
      "real_estate_lawyer_other" : "Outro",
      "residential_real_estate" : "Imobiliário Residencial",
      "title_services" : "Serviços de títulos",
      "trespassing" : "Invasão de propriedade",
      "rehab_other" : "Outro",
      "attic_venting" : "Ventilação do Sótão",
      "gutter_installation" : "Instalação de caleiras",
      "gutter_repair" : "Reparação de Calhas",
      "roof_inspection" : "Inspeção do Telhado",
      "roof_installation" : "Instalação de Telhado",
      "roof_repair" : "Reparação de Telhado",
      "roofer_other" : "Outro",
      "skylight_installation" : "Instalação de Claraboia",
      "skylight_repair" : "Reparação de Claraboia",
      "storm_wind_damage_roof_repair" : "Reparação de Danos no Telhado",
      "sewage_cleaning" : "Limpeza",
      "sewage_excavation" : "Escavação",
      "sewage_inspection" : "Inspeção",
      "sewage_installation" : "Instalação",
      "sewage_locating" : "Localização",
      "sewage_maintenance_repairs" : "Manutenções e reparações",
      "sewage_pro_other" : "Outro",
      "sewage_pumping" : "Bombeamento",
      "sewage_removal_demolition" : "Remoção ou demolição",
      "remodeling_siding_pro" : "Remodelação",
      "repair_maintenance_siding_pro" : "Reparação e manutenção",
      "siding_installation" : "Instalação de Revestimento",
      "siding_pro_other" : "Outro",
      "siding_removal" : "Remoção de revestimento",
      "smart_home_other" : "Outro",
      "commercial_snow_removal" : "Remoção comercial de neve",
      "residential_plowing" : "Abertura de estradas residenciais",
      "residential_shoveling_blowing" : "Remoção de neve residencial",
      "salt_sand_deicing" : "Sal, areia e degelo",
      "snow_relocation" : "Relocalização de neve",
      "snow_removal_other" : "Outro",
      "body_polish" : "Polimento corporal",
      "body_wrap" : "Envolvimento corporal",
      "facial" : "Tratamento facial",
      "hydrotherapy" : "Hidroterapia",
      "manicure" : "Manicure",
      "massage" : "Massagem",
      "pedicure" : "Pedicure",
      "peels" : "Peelings",
      "spa_other" : "Outro",
      "spa_packages" : "Pacotes de Spa",
      "tanning" : "Bronzeamento",
      "waxing" : "Depilação",
      "civil_tax_litigation" : "Contencioso de imposto civil",
      "corporate_taxes" : "Impostos sobre as empresas",
      "criminal_tax_litigation" : "Contencioso imposto penal",
      "estate_tax_planning" : "Planeamento de imposto sobre património",
      "failure_to_file" : "Falha ao apresentar",
      "innocent_spouse_relief" : "Isenção de responsabilidade do cônjuge inocente",
      "international_tax_services" : "Serviços de impostos internacionais",
      "irs_tax_problems" : "Problemas de imposto com o IRS",
      "non_collectible_status" : "Estado não cobrável",
      "offer_in_compromise" : "Oferta de compromisso",
      "tax_audits" : "Auditorias de imposto",
      "tax_lawyer_other" : "Outro",
      "tax_liens_levies" : "Penhoras e impostos",
      "tax_planning_lawyer" : "Planeamento de impostos",
      "tax_relief" : "Redução de impostos",
      "accounting_support" : "Suporte contabilístico",
      "business_incorporation_restructuring" : "Incorporação e reestruturação",
      "cryptocurrency_taxes" : "Impostos sobre criptomoedas",
      "irs_audit_representation" : "Representação de auditoria de IRS",
      "irs_filing" : "Declaração de IRS",
      "irs_problem_consulting" : "Consultoria de problemas de IRS",
      "new_business_services" : "Novos serviços de empresa",
      "payroll_support" : "Suporte para folha de pagamento",
      "tax_planning_tax_specialist" : "Planeamento de impostos",
      "tax_preparation" : "Preparação de Impostos",
      "tax_problem_consulting_tax_specialist" : "Consultoria sobre problemas de imposto",
      "tax_specialist_other" : "Outro",
      "therapist_other" : "Outro",
      "battery_service" : "Serviço de Bateria",
      "car_towing" : "Reboque automóvel",
      "fuel_delivery" : "Entrega de Combustível",
      "local_hauling" : "Transporte Local",
      "long_distance_hauling" : "Transporte de longa distância",
      "motorcycle_towing" : "Reboque de moto",
      "special_vehicle_towing" : "Reboque de Veículos Especiais",
      "tire_change" : "Mudar pneu",
      "towing_other" : "Outro",
      "case_assessment_traffic_lawyer" : "Avaliação de caso",
      "cdl_traffic_ticket" : "Multa de trânsito CDL",
      "dui_dwi_traffic_lawyer" : "Condução sob o efeito do álcool",
      "fixit_ticket" : "Multa de correção",
      "parking_ticket" : "Multa de estacionamento",
      "reckless_driving_traffic_lawyer" : "Condução Imprudente",
      "red_light_ticket" : "Multa por passar semáforo vermelho",
      "speeding_ticket" : "Multa por excesso de velocidade",
      "suspended_license" : "Carta de condução suspensa",
      "traffic_lawyer_other" : "Outro",
      "traffic_ticket" : "Multa de trânsito",
      "cabling_and_bracing" : "Cablagem e fixação",
      "stump_removal" : "Remoção de Tocos",
      "tree_planting" : "Plantação de Árvores",
      "tree_removal" : "Remoção de árvore",
      "tree_service_other" : "Outro",
      "tree_transplanting" : "Transplante de Árvores",
      "tree_trimming_and_pruning" : "Corte e poda de árvores",
      "tutor_computer_science" : "Ciência da Computação",
      "tutor_foreign_languages" : "Línguas Estrangeiras",
      "tutor_geography" : "Geografia",
      "tutor_government_and_economics" : "Governo e Economia",
      "tutor_history" : "Histórico",
      "tutor_homework_help" : "Ajuda com os trabalhos de casa",
      "tutor_math" : "Matemática",
      "tutor_other" : "Outro",
      "tutor_reading_and_writing" : "Ler e escrever",
      "tutor_science" : "Ciência",
      "tutor_special_education" : "Educação Especial",
      "tutor_test_pre_college_entrance" : "Preparação para testes: entrada na faculdade",
      "tutor_test_prep_grad_school_entrance" : "Preparação para testes: entrada em pós-graduação",
      "tutor_test_prep_k8" : "Preparação para testes: K-8",
      "area_rug_cleaning" : "Limpeza de tapetes",
      "drapery_and_blind_cleaning" : "Limpeza de cortinas e estores",
      "leather_cleaning" : "Limpeza de Couro",
      "mattress_cleaning" : "Limpeza de Colchões",
      "upholstery_cleaner_other" : "Outro",
      "upholstery_cleaning" : "Limpeza de Estofos",
      "upholstery_water_damage_cleanup" : "Limpeza de danos de água",
      "bird_exotic_animal_care" : "Cuidados com Aves e Animais Exóticos",
      "farm_barn_animal_care" : "Cuidados de Animais de Quinta e Celeiro",
      "microchipping" : "Microchipagem",
      "veterinarian_allergies" : "Alergias",
      "veterinarian_behavior_counseling" : "Aconselhamento comportamental",
      "veterinarian_dental_care" : "Cuidados dentários",
      "veterinarian_dermatology" : "Dermatologia",
      "veterinarian_emergency_care" : "Cuidados de Emergência",
      "veterinarian_end_of_life_care" : "Cuidados de Fim de Vida",
      "veterinarian_examinations" : "Exames",
      "veterinarian_nutrition_counseling" : "Aconselhamento Nutricional",
      "veterinarian_other" : "Outro",
      "veterinarian_preventive_care" : "Cuidados preventivos",
      "veterinarian_spay_neuter" : "Esterilizar ou Castrar",
      "veterinarian_surgery" : "Cirurgia",
      "veterinarian_vaccinations" : "Vacinas",
      "aerial_videography" : "Videografia Aérea",
      "documentary_video_production" : "Produção de Documentários",
      "family_video_production" : "Produção de Vídeo Familiar",
      "live_streaming" : "Transmissão em direto",
      "photography" : "Fotografia",
      "product_demonstrations" : "Demonstração de Produto",
      "promotional_video_production" : "Produção de vídeo promocional",
      "real_estate_video_production" : "Produção de vídeo imobiliário",
      "special_event_video_production" : "Produção de vídeo de eventos especiais",
      "video_editing" : "Edição de Vídeo",
      "videographer_other" : "Outro",
      "voice_overs" : "Locução",
      "wedding_video_production" : "Produção de Vídeo de Casamento",
      "fire_damage_cleanup_repair" : "Limpeza/reparação de danos causados por incêndio",
      "water_damage_cleanup_repair" : "Limpeza de danos de água",
      "water_damage_flooring" : "Pavimentos",
      "water_damage_mold_inspection" : "Inspeção de bolor",
      "water_damage_mold_removal" : "Remoção de bolor",
      "water_damage_other" : "Outro",
      "water_damage_painting" : "Pintura",
      "water_damage_pest_control" : "Controlo de pragas",
      "water_damage_plumbing" : "Canalização",
      "water_damage_remodeling" : "Remodelação",
      "water_damage_roofing" : "Telhados",
      "water_damage_sewage_cleanup" : "Limpeza de esgoto",
      "adult_weight_loss_programs" : "Programas de perda de peso para adultos",
      "diet_and_nutrition_counseling" : "Aconselhamento de dieta e nutrição",
      "kids_weight_loss_programs" : "Programas de perda de peso para crianças",
      "metabolic_testing" : "Testes Metabólicos",
      "weight_loss_consultation_and_training" : "Consultoria e formação",
      "weight_loss_fitness_programs" : "Programas de Fitness",
      "weight_loss_meal_planning" : "Planeamento de Refeições",
      "weight_loss_personal_training" : "Formação pessoal",
      "weight_loss_service_other" : "Outro",
      "weight_loss_wellness_programs" : "Programas de Bem-estar",
      "glass_and_mirror_cleaning" : "Limpeza de vidros e espelhos",
      "gutter_cleaning" : "Limpeza de Calhas",
      "power_pressure_washing" : "Lavagem a pressão",
      "rooftop_skylight_cleaning" : "Limpeza de telhado/claraboia",
      "window_cleaner_other" : "Outro",
      "window_cleaning" : "Limpeza de janelas",
      "door_installation" : "Instalação de portas",
      "door_repair" : "Reparação de Portas",
      "glass_installation" : "Instalação de Vidro",
      "window_boardup" : "Colocação de tábuas",
      "window_installation" : "Instalação de janelas",
      "window_repair" : "Reparação de Janelas",
      "window_repair_other" : "Outro",
      "install_new_wiper_blades" : "Instalar novas palhetas do limpa-vidros",
      "repair_power_window" : "Reparar janela elétrica",
      "repair_water_leak" : "Reparar fuga de água",
      "repair_windshield" : "Reparar para-brisas",
      "replace_rear_window" : "Substituir janela traseira",
      "replace_side_view_mirrors" : "Reparar espelhos retrovisores laterais",
      "replace_side_window" : "Substituir janela lateral",
      "replace_sunroof" : "Substituir o vidro do teto de abrir",
      "replace_windshield" : "Substituir para-brisas",
      "windshield_other" : "Outro",
      "ashtanga" : "Ashtanga",
      "hatha" : "Hatha",
      "hot_yoga" : "Hot Yoga",
      "iyengar" : "Iyengar",
      "kundalini" : "Kundalini",
      "meditation" : "Meditação",
      "power_yoga" : "Power Yoga",
      "restorative" : "Restaurativo",
      "vinyasa" : "Vinyasa",
      "yin" : "Yin",
      "yoga_instructor_other" : "Outro"
    }
  }
}
